/* eslint-disable eqeqeq */
import { FieldArray, Formik } from "formik";
import { useEffect, useState } from "react";
import Spin from "../../components/Spin";
import { API, fileUpload, invoiceTypeOptions, taxOptions } from "../../config";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import {
  Eye,
  EyeClosedIcon,
  EyeIcon,
  Loader2,
  Plus,
  Trash2,
} from "lucide-react";
import CustomLabelText from "../../components/CustomLabelText";
import { DateInputPicker } from "../../components/DateInputPicker";
import VendorSelect from "../../components/VendorSelect";
import {
  CalculateAmountExcGST,
  CalculateGST,
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import ContactSelect from "../../components/ContactSelect";
import AssetSelect from "../../components/AssetSelect";
import SubAssetSelect from "../../components/SubAssetSelect";
import { AddInvoiceSchema } from "../../lib/Validation";
import ContractSelect from "../../components/ContractSelect";
import moment from "moment";
import SearchSelect from "../../components/SearchSelect";
import JobSelect from "../../components/JobSelect";
import TaskSelect from "../../components/TaskSelect";
import { Textarea } from "../../components/ui/textarea";
// import DiscountCodeSelect from "../../components/DiscountCodeSelect";
import {
  useDiscountCodeList,
  usePremiumList,
  useProcessingFeeList,
} from "../../lib/OptionsAPI";
import CustomTooltip from "../../components/CustomTooltip";
import PreviewInvoice from "./PreviewInvoice";
import { AnimatedTooltip } from "../../components/AnimatedTooltip";
import { useOrganization } from "../../lib/context/OrganisationContext";
import Confirmation from "../../components/Confirmation";
import { LawyerConditon } from "../../lib/PermissionConditions";

const AddEditInvoicing = ({
  id,
  toggleShowAddEditInvoicing,
  edit,
  fetchInvoicingData,
  trustId,
  editItem,
  trustData,
}) => {
  const { organizationData } = useOrganization();
  const [loading, setLoading] = useState(false);

  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorListing, setVendorListing] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const [contactLoading, setContactLoading] = useState(false);
  const [contactListing, setContactListing] = useState([]);
  const [contactList, setContactList] = useState([]);

  const [showView, setShowView] = useState(false);
  const [previewData, setPreviewData] = useState();
  const [showInvoicingApprove, setShowInvoicingApprove] = useState(false);

  const toggleShowModal = (data) => {
    if (showView) {
      setPreviewData();
    } else {
      if (data) {
        handlePreviewData(data);
      }
    }
    setShowView(!showView);
  };

  const toggleShowApprove = () => {
    setShowInvoicingApprove(!showInvoicingApprove);
  };

  const amountTaxTypeList = [
    {
      label: "Tax Exclusive",
      value: "0",
    },
    {
      label: "Tax Inclusive",
      value: "1",
    },
  ];

  // Processing Fees
  const { processingFeeLoading, processingFeeList = [] } =
    useProcessingFeeList(trustId);
  const processingFeeListing = processingFeeList?.map((item) => {
    const {
      id: value,
      code,
      processing_fee_type,
      processing_fee,
      ...rest
    } = item;
    return {
      label: code
        ? `${item.code} (${
            processing_fee_type == 1
              ? `${processing_fee}%`
              : `$${processing_fee}`
          })`
        : "",
      value,
      processing_fee_type,
      processing_fee,
      ...rest,
    };
  });

  // Buyer's Premium
  const {
    premiumLoading,
    showPremium,
    premiumList = [],
  } = usePremiumList(trustId);
  const premiumListing = premiumList?.map((item) => {
    const { id: value, code, premium_type, amount, ...rest } = item;
    return {
      label: code
        ? `${item.code} (${premium_type == 1 ? `${amount}%` : `$${amount}`})`
        : "",
      value,
      premium_type,
      amount,
      ...rest,
    };
  });

  // Buyer's Premium
  const { discountCodeLoading, discountCodeList = [] } =
    useDiscountCodeList(trustId);
  const discountCodeListing = discountCodeList?.map((item) => {
    const { id: value, code, discount_type, discount, ...rest } = item;
    return {
      label: code
        ? `${item.code} (${
            discount_type == 1 ? `${discount}%` : `$${discount}`
          })`
        : "",
      value,
      discount_type,
      discount,
      ...rest,
    };
  });

  const [listingHelper, setListingHelper] = useState([
    {
      asset: {
        listing: [],
        loading: false,
      },
      sub_asset: {
        listing: [],
        loading: false,
      },
      contract: {
        listing: [],
        loading: false,
      },
      receipt: {
        listing: [],
        loading: false,
      },
      job: {
        listing: [],
        loading: false,
      },
      task: {
        listing: [],
        loading: false,
      },
      discount: {
        listing: [],
        loading: false,
      },
    },
  ]);

  const handleFormSubmit = async (values, approve) => {
    const formData = new FormData();

    formData.append("status", approve);
    formData.append("trust_id", trustId);

    formData.append(
      "date",
      moment(values?.date ? values?.date : new Date()).format("DD-MM-YYYY")
    );

    formData.append(
      "due_date",
      moment(
        values?.due_date
          ? values?.due_date
          : new Date(Date.now() + 14 * 24 * 60 * 60 * 1000)
      ).format("DD-MM-YYYY")
    );
    formData.append("note", values?.note);
    formData.append("invoice_number", values?.invoice_number);
    formData.append("contact_id", values?.contact_id ? values?.contact_id : "");
    formData.append("file_type", values?.file_type ? values?.file_type : "1");
    formData.append(
      "amount_tax_type",
      values?.amount_tax_type ? values?.amount_tax_type : ""
    );
    formData.append(
      "processing_fee_id",
      values?.processing_fee_id ? values?.processing_fee_id : ""
    );
    formData.append(
      "processing_fee_amount",
      values?.processing_fee_amount ? values?.processing_fee_amount : ""
    );

    formData.append("premium_id", values?.premium_id ? values?.premium_id : "");
    formData.append(
      "premium_amount",
      values?.premium_amount ? values?.premium_amount : ""
    );
    formData.append(
      "discount_code_id",
      values?.discount_code_id ? values?.discount_code_id : ""
    );
    formData.append(
      "discount_amount",
      values?.discount_amount ? values?.discount_amount : ""
    );

    formData.append(
      "subtotal_amount",
      globalTotals(values)?.totalAmount ? globalTotals(values)?.totalAmount : 0
    );

    formData.append(
      "total_discount_amount",
      globalTotals(values)?.totalDiscountAmount
        ? globalTotals(values)?.totalDiscountAmount
        : 0
    );

    formData.append(
      "total_processing_fee_amount",
      globalTotals(values)?.totalProcessingFeeAmount
        ? globalTotals(values)?.totalProcessingFeeAmount
        : 0
    );

    formData.append(
      "total_premium_amount",
      globalTotals(values)?.totalPremiumAmount
        ? globalTotals(values)?.totalPremiumAmount
        : 0
    );

    formData.append(
      "total_amount",
      globalTotals(values)?.totalAmountExc
        ? globalTotals(values)?.totalAmountExc
        : 0
    );

    formData.append(
      "total_net_amount",
      globalTotals(values)?.totalNetAmount
        ? globalTotals(values)?.totalNetAmount
        : 0
    );

    formData.append(
      "total_gst_amount",
      globalTotals(values)?.totalTaxAmount
        ? globalTotals(values)?.totalTaxAmount
        : 0
    );

    values?.items.forEach((itemData, i) => {
      formData.append(
        `items[${i}][contact_id]`,
        values?.contact_id ? values?.contact_id : ""
      );
      formData.append(
        `items[${i}][contract_id]`,
        itemData?.contract_id ? itemData?.contract_id : ""
      );
      formData.append(
        `items[${i}][vendor_id]`,
        itemData?.vendor_id ? itemData?.vendor_id : ""
      );
      formData.append(
        `items[${i}][asset_id]`,
        itemData?.asset_id ? itemData?.asset_id : ""
      );
      formData.append(
        `items[${i}][sub_asset_id]`,
        itemData?.sub_asset_id ? itemData?.sub_asset_id : ""
      );
      formData.append(
        `items[${i}][ts_job_id]`,
        itemData?.ts_job_id ? itemData?.ts_job_id : ""
      );
      formData.append(
        `items[${i}][ts_task_id]`,
        itemData?.ts_task_id ? itemData?.ts_task_id : ""
      );
      formData.append(`items[${i}][tax]`, itemData?.tax ? itemData?.tax : "1");

      formData.append(
        `items[${i}][tax_percentage]`,
        itemData?.tax_percentage ? itemData?.tax_percentage : "1"
      );

      formData.append(
        `items[${i}][processing_fee_id]`,
        itemData?.processing_fee_id ? itemData?.processing_fee_id : ""
      );

      formData.append(
        `items[${i}][processing_fee_amount]`,
        itemData?.processing_fee_amount ? itemData?.processing_fee_amount : ""
      );

      formData.append(
        `items[${i}][premium_id]`,
        itemData?.premium_id ? itemData?.premium_id : ""
      );

      formData.append(
        `items[${i}][premium_amount]`,
        itemData?.premium_amount ? itemData?.premium_amount : ""
      );

      formData.append(
        `items[${i}][discount_code_id]`,
        itemData?.discount_code_id ? itemData?.discount_code_id : ""
      );

      formData.append(
        `items[${i}][discount_amount]`,
        itemData?.discount_amount ? itemData?.discount_amount : ""
      );

      formData.append(
        `items[${i}][total_amount]`,
        itemData?.total_amount ? itemData?.total_amount : ""
      );

      formData.append(
        `items[${i}][amount]`,
        itemData?.amount ? itemData?.amount : ""
      );

      formData.append(
        `items[${i}][gst_amount]`,
        itemData?.gst_amount ? itemData?.gst_amount : ""
      );

      formData.append(
        `items[${i}][net_amount]`,
        itemData?.net_amount ? itemData?.net_amount : ""
      );

      formData.append(
        `items[${i}][description]`,
        itemData?.description ? itemData?.description : ""
      );
    });

    if (edit) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.INVOICING_ADD}${edit ? `/${id}` : ""}`,
        formData
      );
      setLoading(false);
      if (data) {
        toggleShowAddEditInvoicing();
        fetchInvoicingData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };

  const editInitalValues = () => {
    // Extract unique payment IDs
    // const uniqueIds = editItem
    //   ? [...new Set(editItem?.invoice_items.map((item) => item.invoice_id))]
    //   : [];
    // let invoice_items = uniqueIds;

    let invoiceItem = [];
    for (let i = 0; i < editItem?.invoice_items?.length; i++) {
      invoiceItem.push({
        contact_id: editItem?.contact_id,
        contract_id: editItem?.invoice_items?.[i]?.contract_id
          ? editItem?.invoice_items?.[i]?.contract_id
          : "",
        vendor_id: editItem?.invoice_items?.[i]?.vendor_id,
        asset_id: editItem?.invoice_items?.[i]?.asset_id,
        sub_asset_id: editItem?.invoice_items?.[i]?.sub_asset_id,
        ts_job_id: editItem?.invoice_items?.[i]?.ts_job_id
          ? editItem?.invoice_items?.[i]?.ts_job_id
          : "",
        ts_task_id: editItem?.invoice_items?.[i]?.ts_task_id
          ? editItem?.invoice_items?.[i]?.ts_task_id
          : "",
        total_amount: editItem?.invoice_items?.[i]?.total_amount
          ? editItem?.invoice_items?.[i]?.total_amount
          : 0,
        processing_fee_id: editItem?.invoice_items?.[i]?.processing_fee_id
          ? editItem?.invoice_items?.[i]?.processing_fee_id
          : "",
        processing_fee_amount: editItem?.invoice_items?.[i]
          ?.processing_fee_amount
          ? editItem?.invoice_items?.[i]?.processing_fee_amount
          : 0,
        premium_id: editItem?.invoice_items?.[i]?.premium_id
          ? editItem?.invoice_items?.[i]?.premium_id
          : "",
        premium_amount: editItem?.invoice_items?.[i]?.premium_amount
          ? editItem?.invoice_items?.[i]?.premium_amount
          : 0,
        discount_code_id: editItem?.invoice_items?.[i]?.discount_code_id
          ? editItem?.invoice_items?.[i]?.discount_code_id
          : "",
        discount_amount: editItem?.invoice_items?.[i]?.discount_amount
          ? editItem?.invoice_items?.[i]?.discount_amount
          : 0,
        amount: editItem?.invoice_items?.[i]?.amount
          ? editItem?.invoice_items?.[i]?.amount
          : 0,
        gst_amount: editItem?.invoice_items?.[i]?.gst_amount
          ? editItem?.invoice_items?.[i]?.gst_amount
          : 0,
        net_amount: editItem?.invoice_items?.[i]?.net_amount
          ? editItem?.invoice_items?.[i]?.net_amount
          : 0,
        tax: editItem?.invoice_items?.[i]?.tax
          ? editItem?.invoice_items?.[i]?.tax
          : "1",
        tax_percentage: editItem?.invoice_items?.[i]?.tax_percentage
          ? editItem?.invoice_items?.[i]?.tax_percentage
          : 10,
        description: editItem?.invoice_items?.[i]?.description
          ? editItem?.invoice_items?.[i]?.description
          : "",
        additionalFields: false,
      });
    }
    let object = {
      contact_id: editItem?.contact_id,
      invoice_number: editItem?.invoice_number ? editItem?.invoice_number : "",
      file_type: editItem?.file_type ? editItem?.file_type : "1",
      amount_tax_type: editItem?.amount_tax_type
        ? editItem?.amount_tax_type
        : "1",

      processing_fee_id: editItem?.processing_fee_id
        ? editItem?.processing_fee_id
        : "",
      processing_fee_amount: editItem?.processing_fee_amount
        ? editItem?.processing_fee_amount
        : "",

      premium_id: editItem?.premium_id ? editItem?.premium_id : "",
      premium_amount: editItem?.premium_amount ? editItem?.premium_amount : "",
      discount_code_id: editItem?.discount_code_id
        ? editItem?.discount_code_id
        : "",
      discount_amount: editItem?.discount_amount
        ? editItem?.discount_amount
        : "",

      date: editItem?.date ? moment(editItem?.date, "YYYY-MM-DD") : "",
      due_date: editItem?.due_date
        ? moment(editItem?.due_date, "YYYY-MM-DD")
        : "",
      note: editItem?.note ? editItem?.note : "",
    };

    object.items = invoiceItem;

    return object;
  };

  const initialValues = editItem
    ? editInitalValues()
    : {
        contact_id: "",
        invoice_number: "",
        file_type: "1",
        amount_tax_type: "0",
        processing_fee_id: "",
        processing_fee_amount: "",
        premium_id: "",
        premium_amount: "",
        discount_code_id: "",
        discount_amount: "",
        date: "",
        due_date: "",
        note: "",
        items: [
          {
            contact_id: "",
            contract_id: "",
            vendor_id: "",
            asset_id: "",
            sub_asset_id: "",
            ts_job_id: "",
            ts_task_id: "",
            // payment_method: "",
            total_amount: "",
            amount: "",
            gst_amount: "",
            net_amount: "",
            tax: "1",
            tax_percentage: "",
            description: "",
            additionalFields: false,
          },
        ],
      };

  useEffect(() => {
    if (vendorList) {
      let vendorTempListing = vendorList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setVendorListing(vendorTempListing || []);
    } else {
      setVendorListing([]);
    }
  }, [vendorList]);

  useEffect(() => {
    if (contactList) {
      let contactTempListing = contactList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setContactListing(contactTempListing || []);
    } else {
      setContactListing([]);
    }
  }, [contactList]);

  const fixedNumber = (number) => {
    return Number(Number(number).toFixed(2));
  };

  const discountCalculate = ({
    amount_tax_type,
    setFieldValue,
    totalAmount: totalAmountData,
    processing_fee_id,
    processingFeeData,
    premium_id,
    premiumData,
    discount_code_id,
    discountData,
    pIndex,
    subAssetData,
    tax,
  }) => {
    let mainTotalAmount = totalAmountData ? totalAmountData : 0;

    let totalAmount = totalAmountData ? totalAmountData : 0;

    if (processing_fee_id) {
      if (processingFeeData?.processing_fee_type == 1) {
        let processing_feeAmount = totalAmount
          ? fixedNumber((totalAmount * processingFeeData?.processing_fee) / 100)
          : 0;
        setFieldValue(
          `items.${pIndex}.processing_fee_amount`,
          processing_feeAmount
        );

        totalAmount = Number(totalAmount) + Number(processing_feeAmount);
      }
      if (processingFeeData?.processing_fee_type == 0) {
        let processing_feeAmount = totalAmount
          ? fixedNumber(processingFeeData?.processing_fee)
          : 0;
        setFieldValue(
          `items.${pIndex}.processing_fee_amount`,
          processing_feeAmount
        );
        totalAmount = Number(totalAmount) + Number(processing_feeAmount);
      }
    }

    if (premium_id) {
      if (premiumData?.premium_type == 1) {
        let premiumAmount = mainTotalAmount
          ? fixedNumber((mainTotalAmount * premiumData?.amount) / 100)
          : 0;
        setFieldValue(`items.${pIndex}.premium_amount`, premiumAmount);

        totalAmount = Number(totalAmount) + Number(premiumAmount);
      }
      if (premiumData?.premium_type == 0) {
        let premiumAmount = mainTotalAmount
          ? fixedNumber(premiumData?.amount)
          : 0;
        setFieldValue(`items.${pIndex}.premium_amount`, premiumAmount);
        totalAmount = Number(totalAmount) + Number(premiumAmount);
      }
    }

    if (discount_code_id && discountData) {
      if (discountData?.discount_type === 1) {
        let discountAmount = totalAmount
          ? fixedNumber((totalAmount * discountData?.discount) / 100)
          : 0;
        setFieldValue(`items.${pIndex}.discount_amount`, discountAmount);

        setFieldValue(
          `items.${pIndex}.net_amount`,
          fixedNumber(totalAmount - discountAmount)
        );
      }
      if (discountData?.discount_type === 0) {
        // let discountAmount = totalAmount
        //   ? fixedNumber(totalAmount - discountData?.discount)
        //   : 0;
        let discountAmount = discountData?.discount
          ? fixedNumber(discountData?.discount)
          : 0;
        setFieldValue(`items.${pIndex}.discount_amount`, discountAmount);
        setFieldValue(
          `items.${pIndex}.net_amount`,
          fixedNumber(totalAmount - discountAmount)
        );
      }
    } else {
      setFieldValue(`items.${pIndex}.net_amount`, fixedNumber(totalAmount));
    }

    let gst_price = CalculateGST(
      amount_tax_type,
      tax,
      totalAmount,
      subAssetData?.tax_percentage
    );

    let gstAmount = 0;
    if (discount_code_id) {
      if (discountData?.discount_type === 1) {
        let discountAmount = gst_price
          ? fixedNumber((gst_price * discountData?.discount) / 100)
          : 0;

        setFieldValue(
          `items.${pIndex}.gst_amount`,
          fixedNumber(gst_price - discountAmount)
        );
        gstAmount = fixedNumber(gst_price - discountAmount);
      }
      if (discountData?.discount_type === 0) {
        // let discountAmount = gst_price
        //   ? fixedNumber(gst_price - discountData?.discount)
        //   : 0;
        let discountAmount = gst_price
          ? fixedNumber(discountData?.discount)
          : 0;
        setFieldValue(
          `items.${pIndex}.gst_amount`,
          fixedNumber(gst_price - discountAmount)
        );
        gstAmount = fixedNumber(gst_price - discountAmount);
      }
    } else {
      setFieldValue(`items.${pIndex}.gst_amount`, fixedNumber(gst_price));
      gstAmount = fixedNumber(gst_price);
    }

    if (discount_code_id) {
      if (discountData?.discount_type === 1) {
        let netAmount = fixedNumber(
          totalAmount -
            (totalAmount
              ? fixedNumber((totalAmount * discountData?.discount) / 100)
              : 0)
        );

        let amount_exc = CalculateAmountExcGST(
          amount_tax_type,
          tax,
          netAmount,
          subAssetData?.tax_percentage
        );

        setFieldValue(`items.${pIndex}.amount`, fixedNumber(amount_exc));
        amount_tax_type === "0" &&
          setFieldValue(
            `items.${pIndex}.net_amount`,
            fixedNumber(amount_exc) + fixedNumber(gstAmount)
          );
      }
      if (discountData?.discount_type === 0) {
        // let netAmount = fixedNumber(
        //   totalAmount -
        //     (totalAmount
        //       ? fixedNumber(totalAmount - discountData?.discount)
        //       : 0)
        let netAmount = fixedNumber(
          totalAmount - (totalAmount ? fixedNumber(discountData?.discount) : 0)
        );

        let amount_exc = CalculateAmountExcGST(
          amount_tax_type,
          tax,
          netAmount,
          subAssetData?.tax_percentage
        );

        setFieldValue(`items.${pIndex}.amount`, fixedNumber(amount_exc));
        amount_tax_type === "0" &&
          setFieldValue(
            `items.${pIndex}.net_amount`,
            fixedNumber(amount_exc) + fixedNumber(gstAmount)
          );
      }
    } else {
      let amount_exc = CalculateAmountExcGST(
        amount_tax_type,
        tax,
        totalAmount,
        subAssetData?.tax_percentage
      );

      setFieldValue(`items.${pIndex}.amount`, fixedNumber(amount_exc));
      amount_tax_type === "0" &&
        setFieldValue(
          `items.${pIndex}.net_amount`,
          fixedNumber(amount_exc) + fixedNumber(gstAmount)
        );
    }
  };

  const handlePreviewData = (data) => {
    let subtotal_amount = globalTotals(data)?.totalAmount
      ? globalTotals(data)?.totalAmount
      : 0;

    let total_discount_amount = globalTotals(data)?.totalDiscountAmount
      ? globalTotals(data)?.totalDiscountAmount
      : 0;

    let total_processing_fee_amount = globalTotals(data)
      ?.totalProcessingFeeAmount
      ? globalTotals(data)?.totalProcessingFeeAmount
      : 0;

    let total_premium_amount = globalTotals(data)?.totalPremiumAmount
      ? globalTotals(data)?.totalPremiumAmount
      : 0;

    let total_amount = globalTotals(data)?.totalAmountExc
      ? globalTotals(data)?.totalAmountExc
      : 0;

    let total_net_amount = globalTotals(data)?.totalNetAmount
      ? globalTotals(data)?.totalNetAmount
      : 0;

    let total_gst_amount = globalTotals(data)?.totalTaxAmount
      ? globalTotals(data)?.totalTaxAmount
      : 0;

    let finalData = {
      ...data,
      trust: trustData,
      trust_id: trustId,
      subtotal_amount,
      total_discount_amount,
      total_processing_fee_amount,
      total_premium_amount,
      total_amount,
      total_gst_amount,
      total_net_amount,
      contact:
        contactListing?.find((item) => item.id === data?.contact_id) || null,
      invoice_items: data.items.map((item, index) => ({
        ...item,
        contact: contactListing?.find((c) => c.id === item.contact_id) || null,
        vendor: vendorListing?.find((v) => v.value === item.vendor_id) || null,
        asset:
          listingHelper?.[index]?.asset.listing.find(
            (x) => x.id === item.asset_id
          ) || null,
        sub_asset:
          listingHelper?.[index]?.sub_asset.listing.find(
            (x) => x.id === item.sub_asset_id
          ) || null,
        processing_fee:
          processingFeeList?.find((p) => p.value === item.processing_fee_id) ||
          null,
        premium:
          premiumListing?.find((p) => p.value === item.premium_id) || null,
        discount_code:
          listingHelper?.[index]?.discount.listing.find(
            (x) => x.id === item.discount_code_id
          ) || null,

        contract:
          listingHelper?.[index]?.contract.listing.find(
            (x) => x.id === item.contract_id
          ) || null,

        job:
          listingHelper?.[index]?.job.listing.find(
            (x) => x.id === item.job_id
          ) || null,

        task:
          listingHelper?.[index]?.task.listing.find(
            (x) => x.id === item.task_id
          ) || null,
      })),
    };

    setPreviewData(finalData);
  };

  const globalTotals = (values) => {
    let totalAmount = Number(
      values?.items
        ?.flatMap((itemData) => itemData)
        ?.reduce(
          (sum, item) =>
            sum + Number(`${item?.total_amount}`.replace(/,/g, "")),
          0
        )
        .toFixed(2)
    );

    let totalProcessingFeeAmount = values?.processing_fee_id
      ? Number(values?.processing_fee_amount)
      : Number(
          values?.items
            ?.flatMap((itemData) => itemData)
            ?.reduce(
              (sum, item) =>
                sum +
                Number(
                  `${
                    item?.processing_fee_amount
                      ? item?.processing_fee_amount
                      : 0
                  }`.replace(/,/g, "")
                ),
              0
            )
            .toFixed(2)
        );

    let totalPremiumAmount = values?.premium_id
      ? Number(values?.premium_amount)
      : Number(
          values?.items
            ?.flatMap((itemData) => itemData)
            ?.reduce(
              (sum, item) =>
                sum +
                Number(
                  `${item?.premium_amount ? item?.premium_amount : 0}`.replace(
                    /,/g,
                    ""
                  )
                ),
              0
            )
            .toFixed(2)
        );

    let subTotal =
      values?.premium_id || values?.processing_fee_id
        ? Number(totalAmount) +
          Number(values?.premium_amount) +
          Number(values?.processing_fee_amount)
        : Number(totalAmount) +
          Number(
            values?.items
              ?.flatMap((itemData) => itemData)
              ?.reduce(
                (sum, item) =>
                  sum +
                  Number(
                    `${
                      item?.premium_amount ? item?.premium_amount : 0
                    }`.replace(/,/g, "")
                  ),
                0
              )
              .toFixed(2)
          ) +
          Number(
            values?.items
              ?.flatMap((itemData) => itemData)
              ?.reduce(
                (sum, item) =>
                  sum +
                  Number(
                    `${
                      item?.processing_fee_amount
                        ? item?.processing_fee_amount
                        : 0
                    }`.replace(/,/g, "")
                  ),
                0
              )
              .toFixed(2)
          );

    let totalDiscountAmount = values?.discount_code_id
      ? Number(values?.discount_amount)
      : Number(
          values?.items
            ?.flatMap((itemData) => itemData)
            ?.reduce(
              (sum, item) =>
                sum +
                Number(
                  `${
                    item?.discount_amount ? item?.discount_amount : 0
                  }`.replace(/,/g, "")
                ),
              0
            )
            .toFixed(2)
        );

    let totalTaxAmount = Number(
      values?.items
        ?.flatMap((itemData) => itemData)
        ?.reduce(
          (sum, item) => sum + Number(`${item?.gst_amount}`.replace(/,/g, "")),
          0
        )
        .toFixed(2)
    );

    let premiumData = premiumListing?.find(
      (item) => item.value === values?.premium_id
    );

    if (values?.premium_id) {
      if (premiumData?.premium_type == 1) {
        let premiumAmount = totalTaxAmount
          ? fixedNumber((totalTaxAmount * Number(premiumData?.amount)) / 100)
          : 0;

        // gst_price = fixedNumber(gst_price + premiumAmount);
        totalTaxAmount = fixedNumber(totalTaxAmount + premiumAmount);
      }
      if (premiumData?.premium_type == 0) {
        let premiumAmount = totalTaxAmount
          ? fixedNumber(totalTaxAmount - Number(premiumData?.amount))
          : 0;
        // gst_price = fixedNumber(gst_price + premiumAmount);
        totalTaxAmount = fixedNumber(totalTaxAmount + premiumAmount);
      }
    }

    let discountData = discountCodeListing?.find(
      (item) => item.value === values?.discount_code_id
    );

    if (values?.discount_code_id) {
      if (discountData?.discount_type == 1) {
        let discountAmount = totalTaxAmount
          ? fixedNumber((totalTaxAmount * discountData?.discount) / 100)
          : 0;

        totalTaxAmount = fixedNumber(totalTaxAmount - discountAmount);
      }
      if (discountData?.discount_type == 0) {
        // let discountAmount = totalTaxAmount
        //   ? fixedNumber(totalTaxAmount - discountData?.discount)
        //   : 0;
        let discountAmount = totalTaxAmount
          ? fixedNumber(discountData?.discount)
          : 0;
        totalTaxAmount = fixedNumber(totalTaxAmount - discountAmount);
      }
    }

    let totalNetAmount =
      values?.discount_code_id || values?.premium_id
        ? values?.amount_tax_type === "1"
          ? Number(
              Number(Number(subTotal) - Number(totalDiscountAmount)).toFixed(2)
            )
          : Number(
              Number(
                Number(
                  Number(
                    Number(subTotal) - Number(totalDiscountAmount)
                  ).toFixed(2)
                ) + Number(totalTaxAmount)
              ).toFixed(2)
            )
        : Number(
            values?.items
              ?.flatMap((itemData) => itemData)
              ?.reduce(
                (sum, item) =>
                  sum + Number(`${item?.net_amount}`.replace(/,/g, "")),
                0
              )
              .toFixed(2)
          );

    let totalAmountExc =
      values?.discount_code_id || values?.premium_id
        ? values?.amount_tax_type === "1"
          ? Number(
              Number(Number(totalNetAmount) - Number(totalTaxAmount)).toFixed(2)
            )
          : Number(
              Number(Number(subTotal) - Number(totalDiscountAmount)).toFixed(2)
            )
        : Number(
            values?.items
              ?.flatMap((itemData) => itemData)
              ?.reduce(
                (sum, item) =>
                  sum + Number(`${item?.amount}`.replace(/,/g, "")),
                0
              )
              .toFixed(2)
          );

    return {
      totalAmount,
      totalProcessingFeeAmount,
      totalPremiumAmount,
      subTotal,
      totalDiscountAmount,
      totalAmountExc,
      totalTaxAmount,
      totalNetAmount,
    };
  };

  const globalDiscountCalculate = ({
    totalAmount: totalAmountData,
    itemAmount,
    itemDataIndex,
    values,
    setFieldValue,
    processing_fee_id,
    premium_id,
    discount_code_id,
    amount_tax_type,
    tax,
    pIndex,
    clearItemPremium = false,
    clearItemProcessingFee = false,
    clearItemDiscount = false,
  }) => {
    let mainTotalAmount =
      totalAmountData !== ""
        ? Number(
            values?.items
              ?.flatMap((itemData) => itemData)
              ?.reduce(
                (sum, item) =>
                  sum + Number(`${item?.total_amount}`.replace(/,/g, "")),
                0
              )
              .toFixed(2)
          ) -
          Number(itemAmount ? itemAmount : 0) +
          Number(totalAmountData ? totalAmountData : 0)
        : Number(
            values?.items
              ?.flatMap((itemData) => itemData)
              ?.reduce(
                (sum, item) =>
                  sum + Number(`${item?.total_amount}`.replace(/,/g, "")),
                0
              )
              .toFixed(2)
          );

    let totalAmount =
      totalAmountData !== ""
        ? Number(
            values?.items
              ?.flatMap((itemData) => itemData)
              ?.reduce(
                (sum, item) =>
                  sum + Number(`${item?.total_amount}`.replace(/,/g, "")),
                0
              )
              .toFixed(2)
          ) -
          Number(itemAmount ? itemAmount : 0) +
          Number(totalAmountData ? totalAmountData : 0)
        : Number(
            values?.items
              ?.flatMap((itemData) => itemData)
              ?.reduce(
                (sum, item) =>
                  sum + Number(`${item?.total_amount}`.replace(/,/g, "")),
                0
              )
              .toFixed(2)
          );

    setFieldValue(`processing_fee_id`, processing_fee_id);

    let globalProcessingFeeData = processing_fee_id
      ? processingFeeListing?.find((item) => item.value === processing_fee_id)
      : null;
    let processingFeeAmount = 0;

    if (processing_fee_id) {
      if (globalProcessingFeeData?.processing_fee_type == 1) {
        processingFeeAmount = mainTotalAmount
          ? fixedNumber(
              (mainTotalAmount * globalProcessingFeeData?.processing_fee) / 100
            )
          : 0;
        setFieldValue(`processing_fee_amount`, processingFeeAmount);

        totalAmount = Number(totalAmount) + Number(processingFeeAmount);
      }
      if (globalProcessingFeeData?.processing_fee_type == 0) {
        processingFeeAmount = mainTotalAmount
          ? fixedNumber(globalProcessingFeeData?.processing_fee)
          : 0;
        setFieldValue(`processing_fee_amount`, processingFeeAmount);
        totalAmount = Number(totalAmount) + Number(processingFeeAmount);
      }
    }

    setFieldValue(`premium_id`, premium_id);

    let globalPremiumData = premium_id
      ? premiumListing?.find((item) => item.value === premium_id)
      : null;
    let premiumAmount = 0;

    if (premium_id) {
      if (globalPremiumData?.premium_type == 1) {
        premiumAmount = mainTotalAmount
          ? fixedNumber((mainTotalAmount * globalPremiumData?.amount) / 100)
          : 0;
        setFieldValue(`premium_amount`, premiumAmount);

        totalAmount = Number(totalAmount) + Number(premiumAmount);
      }
      if (globalPremiumData?.premium_type == 0) {
        premiumAmount = mainTotalAmount
          ? fixedNumber(globalPremiumData?.amount)
          : 0;
        setFieldValue(`premium_amount`, premiumAmount);
        totalAmount = Number(totalAmount) + Number(premiumAmount);
      }
    }

    let globalDiscountData = discount_code_id
      ? discountCodeListing?.find((item) => item.value === discount_code_id)
      : null;

    if (discount_code_id) {
      let sumAmount = Number(totalAmount);
      if (globalDiscountData?.discount_type === 1) {
        let discountAmount = sumAmount
          ? fixedNumber((sumAmount * globalDiscountData?.discount) / 100)
          : 0;
        setFieldValue(`discount_amount`, discountAmount);
      }
      if (globalDiscountData?.discount_type === 0) {
        // let discountAmount = sumAmount
        //   ? fixedNumber(sumAmount - globalDiscountData?.discount)
        //   : 0;
        let discountAmount = sumAmount
          ? fixedNumber(globalDiscountData?.discount)
          : 0;
        setFieldValue(`discount_amount`, discountAmount);
      }
    }

    for (let itemIndex = 0; itemIndex < values?.items?.length; itemIndex++) {
      if (processing_fee_id) {
        setFieldValue(`items.${itemIndex}.processing_fee_id`, "");
        setFieldValue(`items.${itemIndex}.processing_fee_amount`, "");
      }
      if (premium_id) {
        setFieldValue(`items.${itemIndex}.premium_id`, "");
        setFieldValue(`items.${itemIndex}.premium_amount`, "");
      }
      if (discount_code_id) {
        setFieldValue(`items.${itemIndex}.discount_code_id`, "");
        setFieldValue(`items.${itemIndex}.discount_amount`, "");
      }
      let discountData = clearItemDiscount
        ? false
        : globalDiscountData
        ? false
        : discountCodeListing?.find(
            (item) =>
              item.value === values?.items?.[itemIndex]?.discount_code_id
          );

      let processingFeeData = clearItemProcessingFee
        ? false
        : globalProcessingFeeData
        ? false
        : processingFeeListing?.find(
            (item) =>
              item.value === values?.items?.[itemIndex]?.processing_fee_id
          );

      let premiumData = clearItemPremium
        ? false
        : globalPremiumData
        ? false
        : premiumListing?.find(
            (item) => item.value === values?.items?.[itemIndex]?.premium_id
          );
      let subAssetData = listingHelper[itemIndex]?.sub_asset?.listing?.find(
        (item) => item.value === values?.sub_asset_id
      );
      discountCalculate({
        amount_tax_type: amount_tax_type
          ? amount_tax_type
          : values?.amount_tax_type
          ? values?.amount_tax_type
          : "0",
        setFieldValue,
        totalAmount:
          itemDataIndex === itemIndex && itemAmount && itemAmount !== ""
            ? totalAmountData
            : values?.items?.[itemIndex]?.total_amount,

        processing_fee_id: clearItemProcessingFee
          ? ""
          : globalProcessingFeeData
          ? ""
          : values?.items?.[itemIndex]?.processing_fee_id
          ? values?.items?.[itemIndex]?.processing_fee_id
          : "",
        processingFeeData,

        premium_id: clearItemPremium
          ? ""
          : globalPremiumData
          ? ""
          : values?.items?.[itemIndex]?.premium_id
          ? values?.items?.[itemIndex]?.premium_id
          : "",
        premiumData,
        discount_code_id: clearItemDiscount
          ? ""
          : globalDiscountData
          ? ""
          : values?.items?.[itemIndex]?.discount_code_id
          ? values?.items?.[itemIndex]?.discount_code_id
          : "",
        discountData,
        pIndex: itemIndex,
        subAssetData,
        tax: tax
          ? itemIndex === pIndex
            ? tax
            : values?.items?.[itemIndex]?.tax
          : values?.items?.[itemIndex]?.tax,
      });
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddInvoiceSchema(organizationData)}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true}/>}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box flex max-h-[78vh] bg-muted flex-col gap-4 overflow-y-auto overflow-x-hidden p-2 border rounded-lg">
              <div className="border bg-background rounded-md p-2 shadow-sm space-y-2 flex w-full items-center flex-wrap">
                <div className="flex-1 flex items-center gap-2 flex-wrap">
                  <div className="grid gap-2">
                    <Label htmlFor="date">
                      <CustomLabelText
                        required={true}
                        labelText="Date"
                        errorField={errors?.date}
                      />
                    </Label>
                    <DateInputPicker
                      date={values?.date ? values?.date : new Date()}
                      onSelect={(e) => {
                        setFieldValue("date", e);
                        if (e) {
                          const dueDate = new Date(e);
                          dueDate.setDate(dueDate.getDate() + 14);
                          setFieldValue("due_date", dueDate);
                        }
                      }}
                      className={"text-left"}
                      // inputClassName="w-full"
                      icon={false}
                      disabledDate={{ after: new Date() }}
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="due_date">
                      <CustomLabelText
                        required={true}
                        labelText="Due Date"
                        errorField={errors?.due_date}
                      />
                    </Label>
                    <DateInputPicker
                      date={
                        values?.due_date
                          ? values?.due_date
                          : new Date(Date.now() + 14 * 24 * 60 * 60 * 1000)
                      }
                      onSelect={(e) => {
                        setFieldValue("due_date", e);
                      }}
                      className={"text-left"}
                      disabledDate={{
                        before: values?.date ? values.date : new Date(), // disallow dates before "Date"
                      }}
                      // inputClassName="w-full"
                      icon={false}
                    />
                  </div>

                  <div className="grid gap-2 w-48">
                    <Label htmlFor="invoice_number">
                      <CustomLabelText
                        required={false}
                        labelText="Invoice Number"
                        errorField={errors?.invoice_number}
                        bottomAlign={true}
                      />
                    </Label>
                    <Input
                      type="text"
                      name="invoice_number"
                      value={
                        values?.invoice_number ? values?.invoice_number : ""
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.invoice_number &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2 w-56">
                    <Label htmlFor="note">
                      <CustomLabelText
                        required={false}
                        labelText="Note"
                        errorField={errors?.note}
                        bottomAlign={true}
                      />
                    </Label>
                    <Input
                      type="text"
                      name="note"
                      value={values?.note ? values?.note : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.note &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2">
                    <div className="min-w-0 w-56">
                      <Label htmlFor="contact_id">
                        <CustomLabelText
                          labelText={`${getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "contacts",
                            "Customer"
                          )}`}
                          errorField={errors?.contact_id}
                          required={true}
                          bottomAlign={true}
                        />
                      </Label>
                      <div className="relative mt-2">
                        <ContactSelect
                          trustId={trustId}
                          frameworkData={contactListing} // List of vendors
                          optionType={`${getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "contacts",
                            "Customer"
                          )}`}
                          handleSelect={(e) => {
                            setFieldValue(`contact_id`, e);
                          }}
                          name="contact_id"
                          disabled={false}
                          initialValue={
                            values?.contact_id ? values?.contact_id : ""
                          }
                          setContactList={setContactList} // Update vendor list as new data loads
                          setContactLoading={setContactLoading} // Control loading state
                          onClear={() => {
                            setFieldValue(`contact_id`, "");
                          }}
                          className={
                            errors?.contact_id &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          loading={contactLoading}
                        />
                        {contactLoading && (
                          <span className="absolute top-2 right-2 animate-spin">
                            <Loader2 width={20} height={20} />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="grid gap-2">
                    <div className="min-w-0 w-40">
                      <Label htmlFor="processing_fee_id">
                        <CustomLabelText
                          labelText="Fee Codes"
                          errorField={errors?.processing_fee_id}
                        />
                      </Label>
                      <div className="relative mt-2">
                        <SearchSelect
                          clearable={true}
                          frameworks={processingFeeListing}
                          optionType={"Fees"}
                          handleSelect={(e) => {
                            setFieldValue(`processing_fee_id`, e);

                            globalDiscountCalculate({
                              totalAmount: "",
                              itemAmount: "",
                              values,
                              setFieldValue,
                              processing_fee_id: e,
                              premium_id: values?.premium_id
                                ? values?.premium_id
                                : "",
                              discount_code_id: values?.discount_code_id
                                ? values?.discount_code_id
                                : "",
                            });
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.processing_fee_id &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={false}
                          initialValue={values?.processing_fee_id}
                          onClear={() => {
                            setFieldValue(`processing_fee_id`, "");
                            setFieldValue(`processing_fee_amount`, "");
                            globalDiscountCalculate({
                              totalAmount: "",
                              itemAmount: "",
                              values,
                              setFieldValue,
                              processing_fee_id: "",
                              premium_id: values?.premium_id
                                ? values?.premium_id
                                : "",
                              discount_code_id: values?.discount_code_id
                                ? values?.discount_code_id
                                : "",
                            });
                          }}
                        />
                        {processingFeeLoading && (
                          <span className="absolute top-2 right-2 animate-spin">
                            <Loader2 width={20} height={20} />
                          </span>
                        )}
                        {!processingFeeLoading && values?.processing_fee_id && (
                          <span className="absolute top-2 text-sm text-white right-8 bg-webPrimary w-fit p-1 rounded-md h-5 flex items-center justify-center">
                            {values?.processing_fee_amount}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {showPremium && (
                    <div className="grid gap-2">
                      <div className="min-w-0 w-40">
                        <Label htmlFor="premium_id">
                          <CustomLabelText
                            labelText="Buyer's Premium"
                            errorField={errors?.premium_id}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SearchSelect
                            clearable={true}
                            frameworks={premiumListing}
                            optionType={"Premium"}
                            handleSelect={(e) => {
                              setFieldValue(`premium_id`, e);

                              globalDiscountCalculate({
                                totalAmount: "",
                                itemAmount: "",
                                values,
                                setFieldValue,
                                processing_fee_id: values?.processing_fee_id
                                  ? values?.processing_fee_id
                                  : "",
                                premium_id: e,
                                discount_code_id: values?.discount_code_id
                                  ? values?.discount_code_id
                                  : "",
                              });
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.premium_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={false}
                            initialValue={values?.premium_id}
                            onClear={() => {
                              setFieldValue(`premium_id`, "");
                              setFieldValue(`premium_amount`, "");
                              globalDiscountCalculate({
                                totalAmount: "",
                                itemAmount: "",
                                values,
                                setFieldValue,
                                processing_fee_id: values?.processing_fee_id
                                  ? values?.processing_fee_id
                                  : "",
                                premium_id: "",
                                discount_code_id: values?.discount_code_id
                                  ? values?.discount_code_id
                                  : "",
                              });
                            }}
                          />
                          {premiumLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                          {!premiumLoading && values?.premium_id && (
                            <span className="absolute top-2 text-sm text-white right-8 bg-webPrimary w-fit p-1 rounded-md h-5 flex items-center justify-center">
                              {values?.premium_amount}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="grid gap-2">
                    <div className="min-w-0 w-40">
                      <Label htmlFor="discount_code_id">
                        <CustomLabelText
                          labelText="Discount"
                          errorField={errors?.discount_code_id}
                        />
                      </Label>
                      <div className="relative mt-2">
                        <SearchSelect
                          clearable={true}
                          frameworks={discountCodeListing}
                          optionType={"Discount"}
                          handleSelect={(e) => {
                            setFieldValue(`discount_code_id`, e);

                            globalDiscountCalculate({
                              totalAmount: "",
                              itemAmount: "",
                              values,
                              setFieldValue,
                              processing_fee_id: values?.processing_fee_id
                                ? values?.processing_fee_id
                                : "",
                              premium_id: values?.premium_id
                                ? values?.premium_id
                                : "",
                              discount_code_id: e,
                            });
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.discount_code_id &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={false}
                          initialValue={values?.discount_code_id}
                          onClear={() => {
                            setFieldValue(`discount_code_id`, "");
                            setFieldValue(`disocunt_amount`, "");
                            globalDiscountCalculate({
                              totalAmount: "",
                              itemAmount: "",
                              values,
                              setFieldValue,
                              processing_fee_id: values?.processing_fee_id
                                ? values?.processing_fee_id
                                : "",
                              premium_id: values?.premium_id
                                ? values?.premium_id
                                : "",
                              discount_code_id: "",
                            });
                          }}
                        />
                        {discountCodeLoading && (
                          <span className="absolute top-2 right-2 animate-spin">
                            <Loader2 width={20} height={20} />
                          </span>
                        )}
                        {!discountCodeLoading && values?.discount_code_id && (
                          <span className="absolute top-2 text-sm text-white right-8 bg-webPrimary w-fit p-1 rounded-md h-5 flex items-center justify-center">
                            {values?.discount_amount}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="grid gap-2">
                    <div className="min-w-0 w-36">
                      <Label htmlFor="amount_tax_type">
                        <CustomLabelText
                          labelText="Hammer Price are"
                          errorField={errors?.amount_tax_type}
                        />
                      </Label>
                      <div className="relative mt-2">
                        <SearchSelect
                          clearable={false}
                          frameworks={amountTaxTypeList}
                          optionType={"Hammer Price are"}
                          handleSelect={(e) => {
                            setFieldValue(`amount_tax_type`, e);
                            globalDiscountCalculate({
                              totalAmount: "",
                              itemAmount: "",
                              values,
                              setFieldValue,
                              processing_fee_id: values?.processing_fee_id
                                ? values?.processing_fee_id
                                : "",
                              premium_id: values?.premium_id
                                ? values?.premium_id
                                : "",
                              discount_code_id: values?.discount_code_id
                                ? values?.discount_code_id
                                : "",
                              amount_tax_type: e,
                            });
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.amount_tax_type &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={false}
                          initialValue={values?.amount_tax_type}
                          onClear={() => {
                            setFieldValue(`amount_tax_type`, "");
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="grid gap-2">
                    <div className="min-w-0">
                      <Label htmlFor="file_type">
                        <CustomLabelText
                          labelText={
                            <div className="flex items-center gap-2">
                              <div>Invoice Type</div>{" "}
                              {values?.file_type && (
                                <AnimatedTooltip
                                  title={"Preview"}
                                  bottomAlign={true}
                                >
                                  <Eye
                                    width={23}
                                    height={23}
                                    className="text-white fill-webPrimary"
                                    onClick={() => {
                                      toggleShowModal(values);
                                    }}
                                  />
                                </AnimatedTooltip>
                              )}
                            </div>
                          }
                          errorField={errors?.file_type}
                          required={false}
                        />
                      </Label>
                      <div className="relative mt-1">
                        <SearchSelect
                          frameworks={invoiceTypeOptions}
                          optionType={"Invoice Type"}
                          handleSelect={(e) => {
                            setFieldValue(`file_type`, e);
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.file_type &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={false}
                          initialValue={values?.file_type}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <FieldArray name="items">
                {({ push, remove }) => (
                  <>
                    {values.items.map((itemData, pIndex) => (
                      <div
                        key={pIndex}
                        className="border bg-background rounded-md p-2 shadow-sm space-y-2"
                      >
                        <div className="flex justify-between items-center">
                          <h4 className="font-semibold">
                            Item{" "}
                            <span className="text-webPrimary">
                              #{pIndex + 1}
                            </span>
                          </h4>
                          <span className="flex items-center gap-2 justify-center">
                            <CustomTooltip
                              message={
                                values?.items?.[pIndex]?.additionalFields
                                  ? "Hide Fields"
                                  : "Show Fields"
                              }
                            >
                              <Button
                                size="icon"
                                className="h-6 w-6"
                                onClick={() =>
                                  setFieldValue(
                                    `items.${pIndex}.additionalFields`,
                                    !values?.items?.[pIndex]?.additionalFields
                                  )
                                }
                              >
                                {values?.items?.[pIndex]?.additionalFields ? (
                                  <EyeIcon className="h-4 w-4" />
                                ) : (
                                  <EyeClosedIcon className="h-4 w-4" />
                                )}
                              </Button>
                            </CustomTooltip>

                            {pIndex + 1 === values?.items?.length && (
                              <Button
                                type="button"
                                size="icon"
                                onClick={() => {
                                  push({
                                    contact_id: values?.contact_id
                                      ? values?.contact_id
                                      : "",
                                    contract_id: "",
                                    vendor_id: "",
                                    asset_id: "",
                                    sub_asset_id: "",
                                    ts_job_id: "",
                                    ts_task_id: "",
                                    payment_method: "",
                                    amount: "",
                                    gst_amount: "",
                                    net_amount: "",
                                    tax: "1",
                                    tax_percentage: "",
                                    description: "",
                                  });
                                  if (
                                    values?.processing_fee_id ||
                                    values?.premium_id ||
                                    values?.discount_code_id
                                  ) {
                                    globalDiscountCalculate({
                                      totalAmount: 0,
                                      itemAmount: 0,
                                      values,
                                      setFieldValue,
                                      processing_fee_id:
                                        values?.processing_fee_id
                                          ? values?.processing_fee_id
                                          : "",
                                      premium_id: values?.premium_id
                                        ? values?.premium_id
                                        : "",
                                      discount_code_id: values?.discount_code_id
                                        ? values?.discount_code_id
                                        : "",
                                    });
                                  }

                                  setListingHelper((pre) => [
                                    ...pre,
                                    {
                                      asset: {
                                        listing: [],
                                        loading: false,
                                      },
                                      sub_asset: {
                                        listing: [],
                                        loading: false,
                                      },
                                      contract: {
                                        listing: [],
                                        loading: false,
                                      },
                                      job: {
                                        listing: [],
                                        loading: false,
                                      },
                                      task: {
                                        listing: [],
                                        loading: false,
                                      },
                                      discount: {
                                        listing: [],
                                        loading: false,
                                      },
                                    },
                                  ]);
                                }}
                                className="h-6 w-6"
                              >
                                <Plus className="h-4 w-4" />
                              </Button>
                            )}
                            {pIndex > 0 && (
                              <>
                                {pIndex + 1 === values?.items?.length && (
                                  <span>/</span>
                                )}
                                <Button
                                  type="button"
                                  variant="destructive"
                                  size="icon"
                                  onClick={() => {
                                    if (
                                      values?.processing_fee_id ||
                                      values?.premium_id ||
                                      values?.discount_code_id
                                    ) {
                                      globalDiscountCalculate({
                                        totalAmount: 0,
                                        itemAmount:
                                          values?.items?.[pIndex]?.total_amount,
                                        values,
                                        setFieldValue,
                                        processing_fee_id:
                                          values?.processing_fee_id
                                            ? values?.processing_fee_id
                                            : "",
                                        premium_id: values?.premium_id
                                          ? values?.premium_id
                                          : "",
                                        discount_code_id:
                                          values?.discount_code_id
                                            ? values?.discount_code_id
                                            : "",
                                      });
                                    }
                                    remove(pIndex);

                                    setListingHelper((prev) =>
                                      prev.filter(
                                        (_, index) => index !== pIndex
                                      )
                                    );
                                  }}
                                  className="h-6 w-6"
                                >
                                  <Trash2 className="h-4 w-4" />
                                </Button>
                              </>
                            )}
                          </span>
                        </div>

                        {/* Payment Info Fields */}
                        <div
                          className={
                            itemData?.additionalFields
                              ? ""
                              : "grid lg:grid-cols-6 gap-2 items-start w-full"
                          }
                        >
                          <div
                            className={
                              itemData?.additionalFields
                                ? "grid lg:grid-cols-7 sm:grid-cols-2 gap-4"
                                : "grid md:grid-cols-2 lg:col-span-1 md:col-span-5 grid-cols-1 gap-2 items-start"
                            }
                          >
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="asset_id">
                                  <CustomLabelText
                                    required={true}
                                    labelText={`${getModuleNamingBySlug(
                                      organizationData?.organizationData,
                                      "sub-assets",
                                      "Sub Asset"
                                    )}`}
                                    errorField={
                                      errors?.items?.[pIndex]?.sub_asset_id
                                    }
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <SubAssetSelect
                                    trustId={trustId}
                                    assetId={""}
                                    editItem={editItem}
                                    payment_id={id}
                                    frameworkData={
                                      listingHelper[pIndex]?.sub_asset?.listing
                                        ? listingHelper[pIndex]?.sub_asset
                                            ?.listing
                                        : []
                                    } // List of vendors
                                    optionType={`${getModuleNamingBySlug(
                                      organizationData?.organizationData,
                                      "sub-assets",
                                      "Sub Asset"
                                    )}`}
                                    handleSelect={(e) => {
                                      let subAssetData = listingHelper[
                                        pIndex
                                      ]?.sub_asset?.listing?.find(
                                        (item) => item.value === e
                                      );
                                      setFieldValue(
                                        `items.${pIndex}.tax_percentage`,
                                        subAssetData?.tax_percentage
                                      );
                                      setFieldValue(
                                        `items.${pIndex}.tax`,
                                        subAssetData?.tax_type
                                      );

                                      setFieldValue(
                                        `items.${pIndex}.sub_asset_id`,
                                        e
                                      );
                                      setFieldValue(
                                        `items.${pIndex}.contract_id`,
                                        ""
                                      );

                                      setListingHelper((prev) =>
                                        prev.map((item, index) =>
                                          index === pIndex
                                            ? {
                                                ...item,
                                                contract: {
                                                  ...item.contract,
                                                  listing: [],
                                                },
                                              }
                                            : item
                                        )
                                      );

                                      setFieldValue(
                                        `items.${pIndex}.asset_id`,
                                        subAssetData?.asset_id
                                      );

                                      setListingHelper((prev) =>
                                        prev.map((item, index) =>
                                          index === pIndex
                                            ? {
                                                ...item,
                                                asset: {
                                                  ...item.asset,
                                                  listing: [
                                                    {
                                                      ...subAssetData?.asset,
                                                      label: subAssetData?.asset
                                                        ?.name
                                                        ? subAssetData?.asset
                                                            ?.name
                                                        : "",
                                                      value:
                                                        subAssetData?.asset_id
                                                          ? subAssetData?.asset_id
                                                          : "",
                                                    },
                                                  ],
                                                },
                                              }
                                            : item
                                        )
                                      );

                                      setFieldValue(
                                        `items.${pIndex}.vendor_id`,
                                        subAssetData?.vendor_id
                                      );

                                      let processingFeeData =
                                        processingFeeListing?.find(
                                          (item) =>
                                            item.value ===
                                            values?.items?.[pIndex]
                                              ?.processing_fee_id
                                        );

                                      let premiumData = premiumListing?.find(
                                        (item) =>
                                          item.value ===
                                          values?.items?.[pIndex]?.premium_id
                                      );

                                      let discountData =
                                        discountCodeListing?.find(
                                          (item) =>
                                            item.value ===
                                            values?.items?.[pIndex]
                                              ?.discount_code_id
                                        );

                                      discountCalculate({
                                        amount_tax_type: values?.amount_tax_type
                                          ? values?.amount_tax_type
                                          : "0",
                                        setFieldValue,
                                        totalAmount:
                                          values?.items?.[pIndex]?.total_amount,
                                        processing_fee_id:
                                          values?.items?.[pIndex]
                                            ?.processing_fee_id,
                                        processingFeeData,
                                        premium_id:
                                          values?.items?.[pIndex]?.premium_id,
                                        premiumData,
                                        discount_code_id:
                                          values?.items?.[pIndex]
                                            ?.discount_code_id,
                                        discountData,
                                        pIndex,
                                        subAssetData,
                                        tax: subAssetData?.tax_type,
                                      });
                                    }}
                                    name="sub_asset_id"
                                    disabled={false}
                                    initialValue={
                                      values?.items?.[pIndex]?.sub_asset_id
                                        ? values?.items?.[pIndex]?.sub_asset_id
                                        : ""
                                    }
                                    setListingHelper={setListingHelper}
                                    targetIndex={pIndex}
                                    setSubAssetList={false}
                                    setSubAssetLoading={(e) => {
                                      setListingHelper((prev) =>
                                        prev.map((item, index) =>
                                          index === pIndex
                                            ? {
                                                ...item,
                                                sub_asset: {
                                                  ...item.sub_asset,
                                                  loading: e,
                                                },
                                              }
                                            : item
                                        )
                                      );
                                    }} // Control loading state
                                    onClear={() => {
                                      setFieldValue(
                                        `items.${pIndex}.sub_asset_id`,
                                        ""
                                      );
                                      setFieldValue(
                                        `items.${pIndex}.tax_percentage`,
                                        ""
                                      );
                                      setFieldValue(`items.${pIndex}.tax`, "");
                                      setFieldValue(
                                        `items.${pIndex}.contract_id`,
                                        ""
                                      );
                                      setListingHelper((prev) =>
                                        prev.map((item, index) =>
                                          index === pIndex
                                            ? {
                                                ...item,
                                                contract: {
                                                  ...item.contract,
                                                  listing: [],
                                                },
                                              }
                                            : item
                                        )
                                      );
                                    }}
                                    className={
                                      errors?.items?.[pIndex]?.sub_asset_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    loading={
                                      listingHelper?.[pIndex]?.sub_asset
                                        ?.loading
                                    }
                                  />
                                  {listingHelper?.[pIndex]?.sub_asset
                                    ?.loading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>

                            {itemData?.additionalFields && (
                              <div className="grid gap-2">
                                <div className="min-w-0">
                                  <Label htmlFor="asset_id">
                                    <CustomLabelText
                                      labelText={`${getModuleNamingBySlug(
                                        organizationData?.organizationData,
                                        "assets",
                                        "Asset"
                                      )}`}
                                      errorField={
                                        errors?.items?.[pIndex]?.asset_id
                                      }
                                      required={true}
                                    />
                                  </Label>
                                  <div className="mt-2 relative">
                                    <AssetSelect
                                      trustId={trustId}
                                      vendorId={
                                        values?.items?.[pIndex]?.vendor_id
                                          ? values?.items?.[pIndex]?.vendor_id
                                          : ""
                                      }
                                      frameworkData={
                                        listingHelper?.[pIndex]?.asset?.listing
                                          ? listingHelper?.[pIndex]?.asset
                                              ?.listing
                                          : []
                                      }
                                      optionType={`${getModuleNamingBySlug(
                                        organizationData?.organizationData,
                                        "assets",
                                        "Asset"
                                      )}`}
                                      handleSelect={(e) => {
                                        setFieldValue(
                                          `items.${pIndex}.asset_id`,
                                          e
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.sub_asset_id`,
                                          ""
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.contract_id`,
                                          ""
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.receipt_id`,
                                          ""
                                        );
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  sub_asset: {
                                                    ...item.sub_asset,
                                                    listing: [],
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  contract: {
                                                    ...item.contract,
                                                    listing: [],
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  receipt: {
                                                    ...item.receipt,
                                                    listing: [],
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                      }}
                                      name="asset_id"
                                      // disabled={!values?.items?.[pIndex]?.vendor_id}
                                      disabled={true}
                                      initialValue={
                                        values?.items?.[pIndex]?.asset_id
                                          ? values?.items?.[pIndex]?.asset_id
                                          : ""
                                      }
                                      notUsingState={true}
                                      setAssetList={false}
                                      setListingHelper={setListingHelper}
                                      targetIndex={pIndex}
                                      setAssetLoading={(e) =>
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  asset: {
                                                    ...item.asset,
                                                    loading: e,
                                                  },
                                                }
                                              : item
                                          )
                                        )
                                      }
                                      onClear={() => {
                                        setFieldValue(
                                          `items.${pIndex}.asset_id`,
                                          ""
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.sub_asset_id`,
                                          ""
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.contract_id`,
                                          ""
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.receipt_id`,
                                          ""
                                        );
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  sub_asset: {
                                                    ...item.sub_asset,
                                                    listing: [],
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  contract: {
                                                    ...item.contract,
                                                    listing: [],
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  receipt: {
                                                    ...item.receipt,
                                                    listing: [],
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                      }}
                                      className={
                                        errors?.items?.[pIndex]?.asset_id &&
                                        `focus-visible:ring-red-500 border-red-500`
                                      }
                                      loading={
                                        listingHelper?.[pIndex]?.asset?.loading
                                      }
                                    />
                                    {listingHelper?.[pIndex]?.asset
                                      ?.loading && (
                                      <span className="absolute top-2 right-2 animate-spin">
                                        <Loader2 width={20} height={20} />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}

                            {itemData?.additionalFields && (
                              <div className="grid gap-2">
                                <div className="min-w-0">
                                  <Label htmlFor="vendor_id">
                                    <CustomLabelText
                                      labelText={`${getModuleNamingBySlug(
                                        organizationData?.organizationData,
                                        "vendors",
                                        "Vendor"
                                      )}`}
                                      errorField={
                                        errors?.items?.[pIndex]?.vendor_id
                                      }
                                      required={true}
                                    />
                                  </Label>
                                  <div className="relative mt-2">
                                    <VendorSelect
                                      trustId={trustId}
                                      frameworkData={vendorListing} // List of vendors
                                      optionType={`${getModuleNamingBySlug(
                                        organizationData?.organizationData,
                                        "vendors",
                                        "Vendor"
                                      )}`}
                                      handleSelect={(e) => {
                                        setFieldValue(
                                          `items.${pIndex}.vendor_id`,
                                          e
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.asset_id`,
                                          ""
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.sub_asset_id`,
                                          ""
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.contract_id`,
                                          ""
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.receipt_id`,
                                          ""
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.listingHelper.asset.listing`,
                                          []
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.listingHelper.sub_asset.listing`,
                                          []
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.listingHelper.contract.listing`,
                                          []
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.listingHelper.receipt.listing`,
                                          []
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.listingHelper.beneficiary.listing`,
                                          []
                                        );

                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  asset: {
                                                    ...item.asset,
                                                    listing: [],
                                                  },
                                                  sub_asset: {
                                                    ...item.sub_asset,
                                                    listing: [],
                                                  },
                                                  contract: {
                                                    ...item.contract,
                                                    listing: [],
                                                  },
                                                  receipt: {
                                                    ...item.receipt,
                                                    listing: [],
                                                  },
                                                  beneficiary: {
                                                    ...item.beneficiary,
                                                    listing: [],
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                      }}
                                      name="vendor_id"
                                      // disabled={false}
                                      disabled={true}
                                      initialValue={
                                        values?.items?.[pIndex]?.vendor_id
                                          ? values?.items?.[pIndex]?.vendor_id
                                          : ""
                                      }
                                      setVendorList={setVendorList} // Update vendor list as new data loads
                                      setVendorLoading={setVendorLoading} // Control loading state
                                      onClear={() => {
                                        setFieldValue(
                                          `items.${pIndex}.vendor_id`,
                                          ""
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.asset_id`,
                                          ""
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.sub_asset_id`,
                                          ""
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.contract_id`,
                                          ""
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.receipt_id`,
                                          ""
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.listingHelper.asset.listing`,
                                          []
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.listingHelper.sub_asset.listing`,
                                          []
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.listingHelper.contract.listing`,
                                          []
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.listingHelper.receipt.listing`,
                                          []
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.listingHelper.beneficiary.listing`,
                                          []
                                        );
                                        setFieldValue(
                                          `items.${pIndex}.payment_data`,
                                          []
                                        );

                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  asset: {
                                                    ...item.asset,
                                                    listing: [],
                                                  },
                                                  sub_asset: {
                                                    ...item.sub_asset,
                                                    listing: [],
                                                  },
                                                  contract: {
                                                    ...item.contract,
                                                    listing: [],
                                                  },
                                                  receipt: {
                                                    ...item.receipt,
                                                    listing: [],
                                                  },
                                                  beneficiary: {
                                                    ...item.beneficiary,
                                                    listing: [],
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                      }}
                                      className={
                                        errors?.items?.[pIndex]?.vendor_id &&
                                        `focus-visible:ring-red-500 border-red-500`
                                      }
                                      loading={vendorLoading}
                                    />
                                    {vendorLoading && (
                                      <span className="absolute top-2 right-2 animate-spin">
                                        <Loader2 width={20} height={20} />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}

                            {itemData?.additionalFields && (
                              <div className="grid gap-2">
                                <div className="min-w-0">
                                  <Label htmlFor="contract_id">
                                    <CustomLabelText
                                      labelText="Agreement/Contract"
                                      errorField={
                                        errors?.items?.[pIndex]?.contract_id
                                      }
                                    />
                                  </Label>
                                  <div className="relative mt-2">
                                    <ContractSelect
                                      trustId={trustId}
                                      subAssetId={
                                        values?.items?.[pIndex]?.sub_asset_id
                                          ? values?.items?.[pIndex]
                                              ?.sub_asset_id
                                          : ""
                                      }
                                      frameworkData={
                                        listingHelper[pIndex]?.contract?.listing
                                          ? listingHelper[pIndex]?.contract
                                              ?.listing
                                          : []
                                      } // List of vendors
                                      optionType="Contract"
                                      handleSelect={(e) => {
                                        setFieldValue(
                                          `items.${pIndex}.contract_id`,
                                          e
                                        );
                                      }}
                                      name="contract_id"
                                      disabled={false}
                                      initialValue={
                                        values?.items?.[pIndex]?.contract_id
                                          ? values?.items?.[pIndex]?.contract_id
                                          : ""
                                      }
                                      setListingHelper={setListingHelper}
                                      targetIndex={pIndex}
                                      setContractList={false}
                                      setContractLoading={(e) => {
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  contract: {
                                                    ...item.contract,
                                                    loading: e,
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                      }} // Control loading state
                                      onClear={() => {
                                        setFieldValue(
                                          `items.${pIndex}.contract_id`,
                                          ""
                                        );
                                      }}
                                      className={
                                        errors?.items?.[pIndex]?.contract_id &&
                                        `focus-visible:ring-red-500 border-red-500`
                                      }
                                      loading={
                                        listingHelper?.[pIndex]?.contract
                                          ?.loading
                                      }
                                    />
                                    {listingHelper?.[pIndex]?.contract
                                      ?.loading && (
                                      <span className="absolute top-2 right-2 animate-spin">
                                        <Loader2 width={20} height={20} />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="gst">
                                  <CustomLabelText
                                    labelText="Tax Type"
                                    errorField={errors?.items?.[pIndex]?.tax}
                                    required={false}
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <SearchSelect
                                    frameworks={taxOptions}
                                    optionType={"Tax Type"}
                                    handleSelect={(e) => {
                                      setFieldValue(`items.${pIndex}.tax`, e);

                                      // let subAssetData = listingHelper[
                                      //   pIndex
                                      // ]?.sub_asset?.listing?.find(
                                      //   (item) =>
                                      //     item.value ===
                                      //     values?.items?.[pIndex]?.sub_asset_id
                                      // );

                                      // let totalAmount = values?.items?.[pIndex]
                                      //   ?.net_amount
                                      //   ? values?.items?.[pIndex]?.net_amount
                                      //   : "";

                                      // let gst_price = CalculateGST(
                                      //   values?.amount_tax_type,
                                      //   e,
                                      //   totalAmount,
                                      //   subAssetData?.tax_percentage
                                      // );

                                      // let amount_exc = CalculateAmountExcGST(
                                      //   values?.amount_tax_type,
                                      //   e,
                                      //   totalAmount,
                                      //   subAssetData?.tax_percentage
                                      // );

                                      // setFieldValue(
                                      //   `items.${pIndex}.net_amount`,
                                      //   totalAmount
                                      // );

                                      // setFieldValue(
                                      //   `items.${pIndex}.amount`,
                                      //   amount_exc
                                      // );

                                      // setFieldValue(
                                      //   `items.${pIndex}.gst_amount`,
                                      //   gst_price
                                      // );

                                      let processingFeeData =
                                        processingFeeListing?.find(
                                          (item) =>
                                            item.value ===
                                            values?.items?.[pIndex]
                                              ?.processing_fee_id
                                        );

                                      let premiumData = premiumListing?.find(
                                        (item) =>
                                          item.value ===
                                          values?.items?.[pIndex]?.premium_id
                                      );

                                      let discountData =
                                        discountCodeListing?.find(
                                          (item) =>
                                            item.value ===
                                            values?.items?.[pIndex]
                                              ?.discount_code_id
                                        );

                                      let subAssetData = listingHelper[
                                        pIndex
                                      ]?.sub_asset?.listing?.find(
                                        (item) =>
                                          item.value === values?.sub_asset_id
                                      );

                                      discountCalculate({
                                        amount_tax_type: values?.amount_tax_type
                                          ? values?.amount_tax_type
                                          : "0",
                                        setFieldValue,
                                        totalAmount:
                                          values?.items?.[pIndex]?.total_amount,
                                        processing_fee_id: values?.items?.[
                                          pIndex
                                        ]?.processing_fee_id
                                          ? values?.items?.[pIndex]
                                              ?.processing_fee_id
                                          : "",
                                        processingFeeData,
                                        premium_id: values?.items?.[pIndex]
                                          ?.premium_id
                                          ? values?.items?.[pIndex]?.premium_id
                                          : "",
                                        premiumData,
                                        discount_code_id: values?.items?.[
                                          pIndex
                                        ]?.discount_code_id
                                          ? values?.items?.[pIndex]
                                              ?.discount_code_id
                                          : "",
                                        discountData,
                                        pIndex,
                                        subAssetData,
                                        tax: e,
                                      });

                                      if (
                                        values?.processing_fee_id ||
                                        values?.premium_id ||
                                        values?.discount_code_id
                                      ) {
                                        globalDiscountCalculate({
                                          totalAmount: "",
                                          itemAmount: "",
                                          values,
                                          setFieldValue,
                                          processing_fee_id:
                                            values?.processing_fee_id
                                              ? values?.processing_fee_id
                                              : "",
                                          premium_id: values?.premium_id
                                            ? values?.premium_id
                                            : "",
                                          discount_code_id:
                                            values?.discount_code_id
                                              ? values?.discount_code_id
                                              : "",
                                          tax: e,
                                          pIndex,
                                        });
                                      }
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.items?.[pIndex]?.tax &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    disabled={false}
                                    initialValue={values?.items?.[pIndex]?.tax}
                                  />
                                </div>
                              </div>
                            </div>

                            {itemData?.additionalFields && !LawyerConditon(organizationData) && (
                              <div className="grid gap-2">
                                <div className="min-w-0">
                                  <Label htmlFor="ts_job_id">
                                    <CustomLabelText
                                      labelText="Job/Matter"
                                      errorField={
                                        errors?.items?.[pIndex]?.ts_job_id
                                      }
                                    />
                                  </Label>
                                  <div className="relative mt-2">
                                    <JobSelect
                                      trustId={trustId}
                                      frameworkData={
                                        listingHelper[pIndex]?.job?.listing
                                          ? listingHelper[pIndex]?.job?.listing
                                          : []
                                      } // List of vendors
                                      optionType="Job/Matter"
                                      handleSelect={(e) => {
                                        setFieldValue(
                                          `items.${pIndex}.ts_job_id`,
                                          e
                                        );
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  task: {
                                                    ...item.task,
                                                    listing: [],
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                      }}
                                      name="ts_job_id"
                                      disabled={false}
                                      initialValue={
                                        values?.items?.[pIndex]?.ts_job_id
                                          ? values?.items?.[pIndex]?.ts_job_id
                                          : ""
                                      }
                                      targetIndex={pIndex}
                                      setListingHelper={setListingHelper}
                                      setJobList={false} // Update vendor list as new data loads
                                      setJobLoading={(e) => {
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  job: {
                                                    ...item.job,
                                                    loading: e,
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                      }}
                                      onClear={() => {
                                        setFieldValue(
                                          `items.${pIndex}.ts_job_id`,
                                          ""
                                        );

                                        setFieldValue(
                                          `items.${pIndex}.ts_task_id`,
                                          ""
                                        );

                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  task: {
                                                    ...item.task,
                                                    listing: [],
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                      }}
                                      className={
                                        errors?.items?.[pIndex]?.ts_job_id &&
                                        `focus-visible:ring-red-500 border-red-500`
                                      }
                                      loading={
                                        listingHelper?.[pIndex]?.job?.loading
                                      }
                                    />
                                    {listingHelper?.[pIndex]?.job?.loading && (
                                      <span className="absolute top-2 right-2 animate-spin">
                                        <Loader2 width={20} height={20} />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}

                            {itemData?.additionalFields && !LawyerConditon(organizationData) && (
                              <div className="grid gap-2">
                                <div className="min-w-0">
                                  <Label htmlFor="ts_task_id">
                                    <CustomLabelText
                                      labelText="Task/Milestone"
                                      errorField={
                                        errors?.items?.[pIndex]?.ts_task_id
                                      }
                                    />
                                  </Label>
                                  <div className="relative mt-2">
                                    <TaskSelect
                                      trustId={trustId}
                                      jobId={
                                        values?.items?.[pIndex]?.ts_job_id
                                          ? values?.items?.[pIndex]?.ts_job_id
                                          : ""
                                      }
                                      frameworkData={
                                        listingHelper?.[pIndex]?.task?.listing
                                          ? listingHelper?.[pIndex]?.task
                                              ?.listing
                                          : []
                                      } // List of vendors
                                      optionType="Task/Milestone"
                                      handleSelect={(e) => {
                                        setFieldValue(
                                          `items.${pIndex}.ts_task_id`,
                                          e
                                        );
                                      }}
                                      name="ts_task_id"
                                      disabled={
                                        !values?.items?.[pIndex]?.ts_job_id
                                      }
                                      initialValue={
                                        values?.items?.[pIndex]?.ts_task_id
                                          ? values?.items?.[pIndex]?.ts_task_id
                                          : ""
                                      }
                                      targetIndex={pIndex}
                                      setListingHelper={setListingHelper}
                                      setTaskList={false} // Update vendor list as new data loads
                                      setTaskLoading={(e) => {
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  task: {
                                                    ...item.task,
                                                    loading: e,
                                                  },
                                                }
                                              : item
                                          )
                                        );
                                      }} // Control loading state
                                      onClear={() => {
                                        setFieldValue(
                                          `items.${pIndex}.ts_task_id`,
                                          ""
                                        );
                                      }}
                                      className={
                                        errors?.items?.[pIndex]?.ts_task_id &&
                                        `focus-visible:ring-red-500 border-red-500`
                                      }
                                      loading={
                                        listingHelper?.[pIndex]?.task?.loading
                                      }
                                    />
                                    {listingHelper?.[pIndex]?.task?.loading && (
                                      <span className="absolute top-2 right-2 animate-spin">
                                        <Loader2 width={20} height={20} />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div
                            key={pIndex}
                            className={
                              itemData?.additionalFields
                                ? `grid sm:grid-cols-2 grid-cols-1 gap-4 items-start !mt-4 ${"lg:grid-cols-7"}`
                                : "grid md:grid-cols-2 lg:grid-cols-9 grid-cols-1 gap-2 items-start md:col-span-5"
                            }
                          >
                            <div className="grid gap-2">
                              <Label>
                                <CustomLabelText
                                  required={false}
                                  labelText={`Hammer Price (${
                                    values?.amount_tax_type === "0"
                                      ? "Ex"
                                      : "Inc"
                                  })`}
                                  errorField={
                                    errors?.items?.[pIndex]?.total_amount
                                  }
                                />
                              </Label>
                              <Input
                                id={`items.${pIndex}.total_amount`}
                                type="number"
                                name={`items.${pIndex}.total_amount`}
                                value={
                                  values?.items?.[pIndex]?.total_amount
                                    ? values?.items?.[pIndex]?.total_amount
                                    : ""
                                }
                                placeholder="Amount"
                                onChange={(e) => {
                                  setFieldValue(
                                    `items.${pIndex}.total_amount`,
                                    e?.target.value
                                  );

                                  let processingFeeData =
                                    processingFeeListing?.find(
                                      (item) =>
                                        item.value ===
                                        values?.items?.[pIndex]
                                          ?.processing_fee_id
                                    );

                                  let premiumData = premiumListing?.find(
                                    (item) =>
                                      item.value ===
                                      values?.items?.[pIndex]?.premium_id
                                  );

                                  let discountData = discountCodeListing?.find(
                                    (item) =>
                                      item.value ===
                                      values?.items?.[pIndex]?.discount_code_id
                                  );

                                  let subAssetData = listingHelper[
                                    pIndex
                                  ]?.sub_asset?.listing?.find(
                                    (item) =>
                                      item.value === values?.sub_asset_id
                                  );

                                  discountCalculate({
                                    amount_tax_type: values?.amount_tax_type
                                      ? values?.amount_tax_type
                                      : "0",
                                    setFieldValue,
                                    totalAmount: e?.target.value
                                      ? e?.target.value
                                      : 0,
                                    processing_fee_id:
                                      values?.items?.[pIndex]
                                        ?.processing_fee_id,
                                    processingFeeData,
                                    premium_id:
                                      values?.items?.[pIndex]?.premium_id,
                                    premiumData,
                                    discount_code_id:
                                      values?.items?.[pIndex]?.discount_code_id,
                                    discountData,
                                    pIndex,
                                    subAssetData,
                                    tax: values?.items?.[pIndex]?.tax,
                                  });

                                  if (
                                    values?.processing_fee_id ||
                                    values?.premium_id ||
                                    values?.discount_code_id
                                  ) {
                                    globalDiscountCalculate({
                                      totalAmount: e?.target.value
                                        ? e?.target.value
                                        : 0,
                                      itemAmount:
                                        values?.items?.[pIndex]?.total_amount,
                                      itemDataIndex: pIndex,
                                      values,
                                      setFieldValue,
                                      processing_fee_id:
                                        values?.processing_fee_id
                                          ? values?.processing_fee_id
                                          : "",
                                      premium_id: values?.premium_id
                                        ? values?.premium_id
                                        : "",
                                      discount_code_id: values?.discount_code_id
                                        ? values?.discount_code_id
                                        : "",
                                    });
                                  }
                                }}
                                onBlur={handleBlur}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                onKeyDown={(e) => {
                                  // Block e, E, +, -
                                  if (["e", "E", "+", "-"].includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onInput={(e) => {
                                  // Prevent negative numbers
                                  if (e.target.value < 0) {
                                    e.target.value = 0;
                                  }
                                }}
                                className={
                                  errors?.items?.[pIndex]?.total_amount &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="processing_fee_id">
                                  <CustomLabelText
                                    labelText="Fee Codes"
                                    errorField={
                                      errors?.items?.[pIndex]?.processing_fee_id
                                    }
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <SearchSelect
                                    clearable={true}
                                    frameworks={processingFeeListing}
                                    optionType={"Fees"}
                                    handleSelect={(e) => {
                                      setFieldValue(
                                        `items.${pIndex}.processing_fee_id`,
                                        e
                                      );

                                      setFieldValue(`processing_fee_id`, "");

                                      setFieldValue(
                                        `processing_fee_amount`,
                                        ""
                                      );

                                      let processingFeeData =
                                        processingFeeListing?.find(
                                          (item) => item.value === e
                                        );

                                      let premiumData = premiumListing?.find(
                                        (item) =>
                                          item.value ===
                                          values?.items?.[pIndex]?.premium_id
                                      );

                                      let discountData =
                                        discountCodeListing?.find(
                                          (item) =>
                                            item.value ===
                                            values?.items?.[pIndex]
                                              ?.discount_code_id
                                        );

                                      let subAssetData = listingHelper[
                                        pIndex
                                      ]?.sub_asset?.listing?.find(
                                        (item) =>
                                          item.value === values?.sub_asset_id
                                      );

                                      discountCalculate({
                                        amount_tax_type: values?.amount_tax_type
                                          ? values?.amount_tax_type
                                          : "0",
                                        setFieldValue,
                                        totalAmount:
                                          values?.items?.[pIndex]?.total_amount,
                                        processing_fee_id: e,
                                        processingFeeData,
                                        premium_id: values?.items?.[pIndex]
                                          ?.premium_id
                                          ? values?.items?.[pIndex]?.premium_id
                                          : "",
                                        premiumData,
                                        discount_code_id: values?.items?.[
                                          pIndex
                                        ]?.discount_code_id
                                          ? values?.items?.[pIndex]
                                              ?.discount_code_id
                                          : "",
                                        discountData,
                                        pIndex,
                                        subAssetData,
                                        tax: values?.items?.[pIndex]?.tax,
                                      });

                                      if (
                                        values?.processing_fee_id ||
                                        values?.premium_id ||
                                        values?.discount_code_id
                                      ) {
                                        globalDiscountCalculate({
                                          totalAmount: "",
                                          itemAmount: "",
                                          values,
                                          setFieldValue,
                                          processing_fee_id:
                                            values?.processing_fee_id
                                              ? values?.processing_fee_id
                                              : "",
                                          premium_id: values?.premium_id
                                            ? values?.premium_id
                                            : "",
                                          discount_code_id:
                                            values?.discount_code_id
                                              ? values?.discount_code_id
                                              : "",
                                        });
                                      }
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.items?.[pIndex]
                                        ?.processing_fee_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    disabled={
                                      values?.processing_fee_id ? true : false
                                    }
                                    initialValue={
                                      values?.items?.[pIndex]?.processing_fee_id
                                    }
                                    onClear={() => {
                                      setFieldValue(
                                        `items.${pIndex}.processing_fee_id`,
                                        ""
                                      );
                                      setFieldValue(
                                        `items.${pIndex}.processing_fee_amount`,
                                        ""
                                      );

                                      let premiumData = premiumListing?.find(
                                        (item) =>
                                          item.value ===
                                          values?.items?.[pIndex]?.premium_id
                                      );

                                      let discountData =
                                        discountCodeListing?.find(
                                          (item) =>
                                            item.value ===
                                            values?.items?.[pIndex]
                                              ?.discount_code_id
                                        );

                                      let subAssetData =
                                        listingHelper[0]?.sub_asset?.listing?.find(
                                          (item) =>
                                            item.value === values?.sub_asset_id
                                        );

                                      discountCalculate({
                                        amount_tax_type: values?.amount_tax_type
                                          ? values?.amount_tax_type
                                          : "0",
                                        setFieldValue,
                                        totalAmount:
                                          values?.items?.[pIndex]?.total_amount,
                                        processing_fee_id: "",
                                        processingFeeData: "",
                                        premium_id: values?.items?.[pIndex]
                                          ?.premium_id
                                          ? values?.items?.[pIndex]?.premium_id
                                          : "",
                                        premiumData: premiumData,
                                        discount_code_id: values?.items?.[
                                          pIndex
                                        ]?.discount_code_id
                                          ? values?.items?.[pIndex]
                                              ?.discount_code_id
                                          : "",
                                        discountData,
                                        pIndex,
                                        subAssetData,
                                        tax: values?.items?.[pIndex]?.tax,
                                      });

                                      if (
                                        values?.processing_fee_id ||
                                        values?.premium_id ||
                                        values?.discount_code_id
                                      ) {
                                        globalDiscountCalculate({
                                          totalAmount: "",
                                          itemAmount: "",
                                          values,
                                          setFieldValue,
                                          processing_fee_id:
                                            values?.processing_fee_id
                                              ? values?.processing_fee_id
                                              : "",
                                          premium_id: values?.premium_id
                                            ? values?.premium_id
                                            : "",
                                          discount_code_id:
                                            values?.discount_code_id
                                              ? values?.discount_code_id
                                              : "",
                                          clearItemProcessingFee: true,
                                        });
                                      }
                                    }}
                                  />
                                  {processingFeeLoading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                  {!processingFeeLoading &&
                                    // !itemData?.additionalFields &&
                                    values?.items?.[pIndex]
                                      ?.processing_fee_id && (
                                      <span className="absolute top-2 text-sm text-white right-8 bg-webPrimary w-fit p-1 rounded-md h-5 flex items-center justify-center">
                                        {
                                          values?.items?.[pIndex]
                                            ?.processing_fee_amount
                                        }
                                      </span>
                                    )}
                                </div>
                              </div>
                            </div>
                            {showPremium && (
                              <>
                                <div className="grid gap-2">
                                  <div className="min-w-0">
                                    <Label htmlFor="premium_id">
                                      <CustomLabelText
                                        labelText="Buyer's Premium"
                                        errorField={
                                          errors?.items?.[pIndex]?.premium_id
                                        }
                                      />
                                    </Label>
                                    <div className="relative mt-2">
                                      <SearchSelect
                                        clearable={true}
                                        frameworks={premiumListing}
                                        optionType={"Premium"}
                                        handleSelect={(e) => {
                                          setFieldValue(
                                            `items.${pIndex}.premium_id`,
                                            e
                                          );

                                          setFieldValue(`premium_id`, "");

                                          setFieldValue(`premium_amount`, "");

                                          let processingFeeData =
                                            processingFeeListing?.find(
                                              (item) =>
                                                item.value ===
                                                values?.items?.[pIndex]
                                                  ?.processing_fee_id
                                            );

                                          let premiumData =
                                            premiumListing?.find(
                                              (item) => item.value === e
                                            );

                                          let discountData =
                                            discountCodeListing?.find(
                                              (item) =>
                                                item.value ===
                                                values?.items?.[pIndex]
                                                  ?.discount_code_id
                                            );

                                          let subAssetData = listingHelper[
                                            pIndex
                                          ]?.sub_asset?.listing?.find(
                                            (item) =>
                                              item.value ===
                                              values?.sub_asset_id
                                          );

                                          discountCalculate({
                                            amount_tax_type:
                                              values?.amount_tax_type
                                                ? values?.amount_tax_type
                                                : "0",
                                            setFieldValue,
                                            totalAmount:
                                              values?.items?.[pIndex]
                                                ?.total_amount,
                                            processing_fee_id: values?.items?.[
                                              pIndex
                                            ]?.processing_fee_id
                                              ? values?.items?.[pIndex]
                                                  ?.processing_fee_id
                                              : "",
                                            processingFeeData,
                                            premium_id: e,
                                            premiumData,
                                            discount_code_id: values?.items?.[
                                              pIndex
                                            ]?.discount_code_id
                                              ? values?.items?.[pIndex]
                                                  ?.discount_code_id
                                              : "",
                                            discountData,
                                            pIndex,
                                            subAssetData,
                                            tax: values?.items?.[pIndex]?.tax,
                                          });

                                          if (
                                            values?.processing_fee_id ||
                                            values?.premium_id ||
                                            values?.discount_code_id
                                          ) {
                                            globalDiscountCalculate({
                                              totalAmount: "",
                                              itemAmount: "",
                                              values,
                                              setFieldValue,
                                              processing_fee_id:
                                                values?.processing_fee_id
                                                  ? values?.processing_fee_id
                                                  : "",
                                              premium_id: values?.premium_id
                                                ? values?.premium_id
                                                : "",
                                              discount_code_id:
                                                values?.discount_code_id
                                                  ? values?.discount_code_id
                                                  : "",
                                            });
                                          }
                                        }}
                                        handleBlur={handleBlur}
                                        className={
                                          errors?.items?.[pIndex]?.premium_id &&
                                          `focus-visible:ring-red-500 border-red-500`
                                        }
                                        disabled={
                                          values?.premium_id ? true : false
                                        }
                                        initialValue={
                                          values?.items?.[pIndex]?.premium_id
                                        }
                                        onClear={() => {
                                          setFieldValue(
                                            `items.${pIndex}.premium_id`,
                                            ""
                                          );
                                          setFieldValue(
                                            `items.${pIndex}.premium_amount`,
                                            ""
                                          );

                                          let processingFeeData =
                                            processingFeeListing?.find(
                                              (item) =>
                                                item.value ===
                                                values?.items?.[pIndex]
                                                  ?.processing_fee_id
                                            );

                                          let discountData =
                                            discountCodeListing?.find(
                                              (item) =>
                                                item.value ===
                                                values?.items?.[pIndex]
                                                  ?.discount_code_id
                                            );

                                          let subAssetData =
                                            listingHelper[0]?.sub_asset?.listing?.find(
                                              (item) =>
                                                item.value ===
                                                values?.sub_asset_id
                                            );

                                          discountCalculate({
                                            amount_tax_type:
                                              values?.amount_tax_type
                                                ? values?.amount_tax_type
                                                : "0",
                                            setFieldValue,
                                            totalAmount:
                                              values?.items?.[pIndex]
                                                ?.total_amount,
                                            processing_fee_id: values?.items?.[
                                              pIndex
                                            ]?.processing_fee_id
                                              ? values?.items?.[pIndex]
                                                  ?.processing_fee_id
                                              : "",
                                            processingFeeData,
                                            premium_id: "",
                                            premiumData: "",
                                            discount_code_id: values?.items?.[
                                              pIndex
                                            ]?.discount_code_id
                                              ? values?.items?.[pIndex]
                                                  ?.discount_code_id
                                              : "",
                                            discountData,
                                            pIndex,
                                            subAssetData,
                                            tax: values?.items?.[pIndex]?.tax,
                                          });

                                          if (
                                            values?.processing_fee_id ||
                                            values?.premium_id ||
                                            values?.discount_code_id
                                          ) {
                                            globalDiscountCalculate({
                                              totalAmount: "",
                                              itemAmount: "",
                                              values,
                                              setFieldValue,
                                              processing_fee_id:
                                                values?.processing_fee_id
                                                  ? values?.processing_fee_id
                                                  : "",
                                              premium_id: values?.premium_id
                                                ? values?.premium_id
                                                : "",
                                              discount_code_id:
                                                values?.discount_code_id
                                                  ? values?.discount_code_id
                                                  : "",
                                              clearItemPremium: true,
                                            });
                                          }
                                        }}
                                      />
                                      {premiumLoading && (
                                        <span className="absolute top-2 right-2 animate-spin">
                                          <Loader2 width={20} height={20} />
                                        </span>
                                      )}
                                      {!premiumLoading &&
                                        // !itemData?.additionalFields &&
                                        values?.items?.[pIndex]?.premium_id && (
                                          <span className="absolute top-2 text-sm text-white right-8 bg-webPrimary w-fit p-1 rounded-md h-5 flex items-center justify-center">
                                            {
                                              values?.items?.[pIndex]
                                                ?.premium_amount
                                            }
                                          </span>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                {/* {itemData?.additionalFields && (
                                  <div className="grid gap-2">
                                    <Label>
                                      <CustomLabelText
                                        required={false}
                                        labelText="Buyer's Premium Amount"
                                        errorField={
                                          errors?.items?.[pIndex]
                                            ?.premium_amount
                                        }
                                      />
                                    </Label>
                                    <Input
                                      id={`items.${pIndex}.premium_amount`}
                                      type="number"
                                      name={`items.${pIndex}.premium_amount`}
                                      value={
                                        values?.items?.[pIndex]?.premium_amount
                                          ? values?.items?.[pIndex]
                                              ?.premium_amount
                                          : "0"
                                      }
                                      placeholder="Buyer's Premium Amount"
                                      disabled={true}
                                      onBlur={handleBlur}
                                      autoComplete="off"
                                      onKeyPress={(e) => {
                                        e.which === 13 && e.preventDefault();
                                      }}
                                      className={
                                        errors?.items?.[pIndex]
                                          ?.premium_amount &&
                                        `focus-visible:ring-red-500 border-red-500`
                                      }
                                    />
                                  </div>
                                )} */}
                              </>
                            )}
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="discount_code_id">
                                  <CustomLabelText
                                    labelText="Discount Code"
                                    errorField={
                                      errors?.items?.[pIndex]?.discount_code_id
                                    }
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <SearchSelect
                                    clearable={true}
                                    frameworks={discountCodeListing}
                                    optionType={"Discount"}
                                    handleSelect={(e) => {
                                      setFieldValue(
                                        `items.${pIndex}.discount_code_id`,
                                        e
                                      );

                                      setFieldValue(`discount_code_id`, "");

                                      setFieldValue(`discount_amount`, "");

                                      let processingFeeData =
                                        processingFeeListing?.find(
                                          (item) =>
                                            item.value ===
                                            values?.items?.[pIndex]
                                              ?.processing_fee_id
                                        );

                                      let premiumData = premiumListing?.find(
                                        (item) =>
                                          item.value ===
                                          values?.items?.[pIndex]?.premium_id
                                      );

                                      let discountData =
                                        discountCodeListing?.find(
                                          (item) => item.value === e
                                        );

                                      let subAssetData = listingHelper[
                                        pIndex
                                      ]?.sub_asset?.listing?.find(
                                        (item) =>
                                          item.value === values?.sub_asset_id
                                      );

                                      discountCalculate({
                                        amount_tax_type: values?.amount_tax_type
                                          ? values?.amount_tax_type
                                          : "0",
                                        setFieldValue,
                                        totalAmount:
                                          values?.items?.[pIndex]?.total_amount,
                                        processing_fee_id:
                                          values?.items?.[pIndex]
                                            ?.processing_fee_id,
                                        processingFeeData,
                                        premium_id:
                                          values?.items?.[pIndex]?.premium_id,
                                        premiumData,
                                        discount_code_id: e,
                                        discountData,
                                        pIndex,
                                        subAssetData,
                                        tax: values?.items?.[pIndex]?.tax,
                                      });

                                      if (
                                        values?.processing_fee_id ||
                                        values?.premium_id ||
                                        values?.discount_code_id
                                      ) {
                                        globalDiscountCalculate({
                                          totalAmount: "",
                                          itemAmount: "",
                                          values,
                                          setFieldValue,
                                          processing_fee_id:
                                            values?.processing_fee_id
                                              ? values?.processing_fee_id
                                              : "",
                                          premium_id: values?.premium_id
                                            ? values?.premium_id
                                            : "",
                                          discount_code_id:
                                            values?.discount_code_id
                                              ? values?.discount_code_id
                                              : "",
                                        });
                                      }
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.items?.[pIndex]
                                        ?.discount_code_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    disabled={
                                      values?.discount_code_id ? true : false
                                    }
                                    initialValue={
                                      values?.items?.[pIndex]?.discount_code_id
                                    }
                                    onClear={() => {
                                      setFieldValue(
                                        `items.${pIndex}.discount_code_id`,
                                        ""
                                      );
                                      setFieldValue(
                                        `items.${pIndex}.discount_amount`,
                                        ""
                                      );

                                      let processingFeeData =
                                        processingFeeListing?.find(
                                          (item) =>
                                            item.value ===
                                            values?.items?.[pIndex]
                                              ?.processing_fee_id
                                        );

                                      let premiumData = premiumListing?.find(
                                        (item) =>
                                          item.value ===
                                          values?.items?.[pIndex]?.premium_id
                                      );

                                      let subAssetData = listingHelper[
                                        pIndex
                                      ]?.sub_asset?.listing?.find(
                                        (item) =>
                                          item.value === values?.sub_asset_id
                                      );

                                      discountCalculate({
                                        amount_tax_type: values?.amount_tax_type
                                          ? values?.amount_tax_type
                                          : "0",
                                        setFieldValue,
                                        totalAmount:
                                          values?.items?.[pIndex]?.total_amount,
                                        processing_fee_id:
                                          values?.items?.[pIndex]
                                            ?.processing_fee_id,
                                        processingFeeData,
                                        premium_id:
                                          values?.items?.[pIndex]?.premium_id,
                                        premiumData,
                                        discount_code_id: "",
                                        discountData: false,
                                        pIndex,
                                        subAssetData,
                                        tax: values?.items?.[pIndex]?.tax,
                                      });

                                      if (
                                        values?.premium_id ||
                                        values?.discount_code_id
                                      ) {
                                        globalDiscountCalculate({
                                          totalAmount: "",
                                          itemAmount: "",
                                          values,
                                          setFieldValue,
                                          processing_fee_id:
                                            values?.processing_fee_id
                                              ? values?.processing_fee_id
                                              : "",
                                          premium_id: values?.premium_id
                                            ? values?.premium_id
                                            : "",
                                          discount_code_id:
                                            values?.discount_code_id
                                              ? values?.discount_code_id
                                              : "",
                                          clearItemDiscount: true,
                                        });
                                      }
                                    }}
                                  />
                                  {discountCodeLoading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                  {!discountCodeLoading &&
                                    // !itemData?.additionalFields &&
                                    values?.items?.[pIndex]
                                      ?.discount_code_id && (
                                      <span className="absolute top-2 text-sm text-white right-8 bg-webPrimary w-fit p-1 rounded-md h-5 flex items-center justify-center">
                                        {
                                          values?.items?.[pIndex]
                                            ?.discount_amount
                                        }
                                      </span>
                                    )}
                                </div>
                              </div>
                            </div>

                            {/* {itemData?.additionalFields && (
                              <div className="grid gap-2">
                                <Label>
                                  <CustomLabelText
                                    required={false}
                                    labelText="Discount Amount"
                                    errorField={
                                      errors?.items?.[pIndex]?.discount_amount
                                    }
                                  />
                                </Label>
                                <Input
                                  id={`items.${pIndex}.discount_amount`}
                                  type="number"
                                  name={`items.${pIndex}.discount_amount`}
                                  value={
                                    values?.items?.[pIndex]?.discount_amount
                                      ? values?.items?.[pIndex]?.discount_amount
                                      : "0"
                                  }
                                  placeholder="Discount Amount"
                                  disabled={true}
                                  onBlur={handleBlur}
                                  autoComplete="off"
                                  onKeyPress={(e) => {
                                    e.which === 13 && e.preventDefault();
                                  }}
                                  className={
                                    errors?.items?.[pIndex]?.discount_amount &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                />
                              </div>
                            )} */}

                            <div className="grid gap-2">
                              <Label>
                                <CustomLabelText
                                  required={false}
                                  labelText="Amount (Ex)"
                                  errorField={errors?.items?.[pIndex]?.amount}
                                />
                              </Label>

                              <Input
                                id={`items.${pIndex}.amount`}
                                type="text"
                                name={`items.${pIndex}.amount`}
                                value={
                                  values?.items?.[pIndex]?.amount
                                    ? values?.items?.[pIndex]?.amount
                                    : ""
                                }
                                placeholder="Amount"
                                disabled={true}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.items?.[pIndex]?.amount &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>

                            <div className="grid gap-2">
                              <Label>
                                <CustomLabelText
                                  required={false}
                                  labelText={`Tax (${
                                    values?.items?.[pIndex]?.tax === "1"
                                      ? values?.items?.[pIndex]?.tax_percentage
                                        ? values?.items?.[pIndex]
                                            ?.tax_percentage
                                        : 10
                                      : 0
                                  }%)`}
                                  errorField={
                                    errors?.items?.[pIndex]?.gst_amount
                                  }
                                />
                              </Label>

                              <Input
                                id={`items.${pIndex}.gst_amount`}
                                type="text"
                                name={`items.${pIndex}.gst_amount`}
                                value={
                                  values?.items?.[pIndex]?.gst_amount
                                    ? values?.items?.[pIndex]?.gst_amount
                                    : "0"
                                }
                                placeholder="Tax Amount"
                                onChange={(e) => {
                                  setFieldValue(
                                    `items.${pIndex}.gst_amount`,
                                    e?.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                disabled={true}
                                className={
                                  errors?.items?.[pIndex]?.gst_amount &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>

                            <div className="grid gap-2">
                              <Label>
                                <CustomLabelText
                                  required={false}
                                  labelText="Net Amount (Inc)"
                                  errorField={
                                    errors?.items?.[pIndex]?.net_amount
                                  }
                                />
                              </Label>
                              <Input
                                id={`items.${pIndex}.net_amount`}
                                type="number"
                                name={`items.${pIndex}.net_amount`}
                                value={
                                  values?.items?.[pIndex]?.net_amount
                                    ? values?.items?.[pIndex]?.net_amount
                                    : ""
                                }
                                placeholder="Net Amount (Inc)"
                                disabled={true}
                                onBlur={handleBlur}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.items?.[pIndex]?.net_amount &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>

                            <div
                              className={
                                itemData?.additionalFields
                                  ? "flex gap-2 lg:col-span-9 md:col-span-2"
                                  : "flex gap-2 md:col-span-2"
                              }
                            >
                              <div className="grid gap-2 flex-1">
                                <Label>
                                  <CustomLabelText
                                    required={false}
                                    labelText="Description"
                                    errorField={
                                      errors?.items?.[pIndex]?.description
                                    }
                                  />
                                </Label>

                                <Textarea
                                  id={`items.${pIndex}.description`}
                                  name={`items.${pIndex}.description`}
                                  value={
                                    values?.items?.[pIndex]?.description
                                      ? values?.items?.[pIndex]?.description
                                      : ""
                                  }
                                  placeholder={"Description"}
                                  onChange={(e) => {
                                    setFieldValue(
                                      `items.${pIndex}.description`,
                                      e?.target?.value
                                    );
                                  }}
                                  onBlur={handleBlur}
                                  autoComplete="off"
                                  onKeyPress={(e) => {
                                    e.which === 13 && e.preventDefault();
                                  }}
                                  className={
                                    errors?.items?.[pIndex]?.description &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </FieldArray>

              <div className="flex w-full items-center justify-end">
                <div className="bg-background p-2 rounded-md w-full sm:w-fit">
                  <p className="w-full sm:w-[320px] flex items-center justify-between">
                    <strong>Hammer Price:</strong> $
                    {formatNumber(globalTotals(values)?.totalAmount)}
                  </p>

                  {globalTotals(values)?.totalProcessingFeeAmount &&
                  globalTotals(values)?.totalProcessingFeeAmount != 0 ? (
                    <p className="w-full sm:w-[320px] flex items-center justify-between">
                      <strong>Processing Fee Amount:</strong> $
                      {formatNumber(
                        globalTotals(values)?.totalProcessingFeeAmount
                      )}
                    </p>
                  ) : (
                    <></>
                  )}

                  {globalTotals(values)?.totalPremiumAmount &&
                  globalTotals(values)?.totalPremiumAmount != 0 ? (
                    <p className="w-full sm:w-[320px] flex items-center justify-between">
                      <strong>Buyer's Premium Amount:</strong> $
                      {formatNumber(globalTotals(values)?.totalPremiumAmount)}
                    </p>
                  ) : (
                    <></>
                  )}

                  {globalTotals(values)?.totalPremiumAmount &&
                  globalTotals(values)?.totalPremiumAmount != 0 ? (
                    <p className="w-full sm:w-[320px] flex items-center justify-between">
                      <strong>Sub Total:</strong> $
                      {formatNumber(globalTotals(values)?.subTotal)}
                    </p>
                  ) : (
                    <></>
                  )}

                  {globalTotals(values)?.totalDiscountAmount &&
                  globalTotals(values)?.totalDiscountAmount != 0 ? (
                    <p className="w-full sm:w-[320px] flex items-center justify-between">
                      <strong>Discount Amount:</strong> $
                      {formatNumber(globalTotals(values)?.totalDiscountAmount)}
                    </p>
                  ) : (
                    <></>
                  )}

                  <p className="w-full sm:w-[320px] flex items-center justify-between">
                    <strong>Total Amount (Ex):</strong> $
                    {formatNumber(globalTotals(values)?.totalAmountExc)}
                  </p>

                  <p className="w-full sm:w-[320px] flex items-center justify-between">
                    <strong>Total Tax Amount:</strong> $
                    {formatNumber(globalTotals(values)?.totalTaxAmount)}
                  </p>

                  <p className="w-full sm:w-[320px] flex items-center justify-between">
                    <strong>Total Net Amount:</strong> $
                    {formatNumber(globalTotals(values)?.totalNetAmount)}
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              {/* <Button type="submit" disabled={!CheckTotal(values) || !isValid}> */}
              <Button
                disabled={!isValid}
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowApprove();
                }}
              >
                Post
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditInvoicing();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
            <Confirmation
              title={"Approve Invoice"}
              loading={loading}
              open={showInvoicingApprove}
              setOpen={setShowInvoicingApprove}
              toggleShow={() => {
                toggleShowApprove();
              }}
              className="sm:max-w-1/2"
              message={"Do you want to approve invoice?"}
              okAction={async () => {
                await handleFormSubmit(values, 1);
                toggleShowApprove();
              }}
              cancelAction={async () => {
                await handleFormSubmit(values, 0);
                setShowInvoicingApprove(!showInvoicingApprove);
              }}
            />
          </form>
          {showView && (
            <PreviewInvoice
              showView={showView}
              setShowView={setShowView}
              data={previewData}
              printShow={false}
            />
          )}
        </>
      )}
    </Formik>
  );
};

export default AddEditInvoicing;
